import dateFormat from 'dateformat';
import {Slide, toast} from "react-toastify";
import swal from "sweetalert";
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import axios from "axios";
import parseHtml from 'html-react-parser';
import {DropdownToggle, DropdownMenu,Nav, NavItem, NavLink,UncontrolledButtonDropdown} from 'reactstrap';
import requestApi from "../services/requestApi.service";
import whatsappApi from "../services/whatsappApi.service";
import {setFormDetails} from "../reducers/ThemeOptions";
import warningIcon from "../assets/utils/images/exclamation.png";
import React from "react";
import {errorMessages} from "../Components/Inbox/utils/common";
//import htmlToDraft from "html-to-draftjs";
//import {ContentState, EditorState,convertToRaw} from "draft-js";
import CratioInput from "../Components/Common/CratioInput";
import CratioDropdownField from "../Components/Common/CratioDropdownField";
import CratioDateField from "../Components/Common/CratioDateField";
import CratioLookup from "../Components/Common/CratioLookup";
import CratioTextInput from "../Components/Common/CratioTextInput";
import CratioNumberInput from "../Components/Common/CratioNumberInput";
import CratioMobileInput from "../Components/Common/CratioMobileInput";
import CratioEmailInput from "../Components/Common/CratioEmailInput";
import CratioIntInput from "../Components/Common/CratioIntInput";
import CratioTextArea from "../Components/Common/CratioTextArea";
import CratioDatePicker from "../Components/Common/CratioDatePicker";
import CratioCurrencyInput from "../Components/Common/CratioCurrencyInput";
import CratioDateTimePicker from "../Components/Common/CratioDateTimePicker";
import CratioFileUploader from "../Components/Common/CratioFileUploader";
import CratioSuggestBox from "../Components/Common/CratioSuggestBox";
import { Loader } from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";
import { custom_filter_options, recipients_mobile_option_list, recipients_option_list } from '../Components/Search/Constants';
import { skipFields } from './Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select, { components } from "react-select";
import BarChart from '../Components/Dashboard/Charts/BarChart';
import PieChart from '../Components/Dashboard/Charts/PieChart';
import FunnelChart from '../Components/Dashboard/Charts/FunnelChart';
import TableChart from '../Components/Dashboard/Charts/TableChart';

class Appcommon {

}
export function showToast(msg, position = "top-right",type="success", onclosecb,autoclose=3000){
    toast(msg, {
        theme: "light",
        position: position,
        autoClose: autoclose,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onClose: onclosecb,
        type:type,
        transition: Slide,
    });
}


export function setSessionValue(key, value){
    let prefix = getHostPrefix();
    localStorage.setItem(prefix+key, value);
}

export function getSessionValue (key){
    let prefix = getHostPrefix();
    let sessionValue = (prefix+key !== undefined && prefix+key !== null && prefix+key !== '') ? prefix+key : key;
    return localStorage.getItem(sessionValue) === null ? '' : localStorage.getItem(sessionValue);
}

export function clearSessionValue(){
    localStorage.clear();
}

export function convertUTCToLocalTime(datevalue, format="dd-mmm-yyyy h:MM TT"){
    if(datevalue !== undefined && !datevalue.toString().includes('Z')){
        datevalue = datevalue + "Z";
    }
    if(datevalue !== undefined && !datevalue.toString().includes('T')){
        datevalue = datevalue.replace(" ","T");
    }
    let converteddatevalue = new Date(datevalue);
    converteddatevalue = converteddatevalue.toString();
    converteddatevalue = dateFormat(converteddatevalue, format);
    return converteddatevalue;
}

export function timeSince(date,curDate) {
    date = new Date(date.replace(" ","T"));
    let currentDate = new Date(curDate.replace(" ","T"));

    var seconds = Math.floor((currentDate - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
        return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hrs";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " min";
    }
    return Math.floor(seconds) + " sec";
}

export function formatDate(datevalue, format="yyyy-mm-dd HH:MM:ss"){
    return dateFormat(datevalue, format);
}

export async function confirmBox(title, message, type = 'warning', btntxt = "OK",cancelText="Cancel"){
    return await swal({
        title: title,
        text: message,
        icon: type,
        buttons: {cancel: {
                text: cancelText,
                value: false,
                visible: true,
                className: "btn btn-link",
                closeModal: true,
            },
            confirm: {
                text: btntxt,
                value: true,
                visible: true,
                className: "btn btn-primary btn-lg text-bold",
                closeModal: true
            }},
        dangerMode: false,
        confirmButtonColor : "green"
    });
}

export async function confirmBoxWithImage(title, message,imageIcon = "", btntxt = "OK", cancelText="Cancel", cancelBtn = "", confirmBtn = "", closeOnClickOutside = true, closeOnEsc = true,needToClose = false){
    return await swal({
        title: title,
        text: message,
        icon: imageIcon === "" ? warningIcon : imageIcon,
        buttons: {
            cancel: cancelBtn === "" ? {
                text: cancelText,
                value: false,
                visible: true,
                className: "",
                closeModal: true,
            } : cancelBtn,
            confirm: confirmBtn === "" ? {
                text: btntxt,
                value: true,
                visible: true,
                className: "",
                closeModal: true
            } : confirmBtn,
            closeBtn:{
                text: 'X',
                value: 'Close',
                visible: needToClose === true ? true : false ,
                className: "swal-button--cancel custom-cancel-button",
                closeModal:true,
            },
        },
        imageWidth: 50,
        imageHeight: 50,
        imageAlt: 'Warning',
        closeOnClickOutside: closeOnClickOutside,
        closeOnEsc: closeOnEsc,
    });
}

export function getServerURL(){
    let appHost = window.location.hostname;
    let protocol = window.location.protocol;
    let subName = "/dacamweb";
    let baseUrl = protocol +"//"+appHost;
    if(appHost !== "localhost"){
        baseUrl = getServerDomainURL();
    }
    return baseUrl + subName;
}

export function convertValuePosition(value){
    if(value < 0) {
        value = value * -1;
    } else if (value > 0){
        value = "-"+value;
    }
    return value;
}
export async function populateFormDetails (formname){
    let params = {
        "ENTITY" : "ApplDirectory",
        "OPERATION" : "FormDetail",
        "formnames" : [formname],
        "Isbuilderreq" : false,
        "ISAPIREQ" : true
    }
    let formData = await requestApi.processServerRequest(params);
    if(formData.issuccess && formData.data.length > 0){
        let formResponse = formData.data;
        if(formResponse[1] !== undefined){
            let moduleDetails = formResponse[1];
            let formDetail = moduleDetails[2][0];
            return formDetail;
        }
    }

    return [];
}
export async function getFormDetails(formname, details){
    let formDetail = [];
    for(let key in details){
        for(let dupkey in details[key][0]){
            if(dupkey === formname){
                formDetail = details[key][0][dupkey];
                return formDetail;
            }
        }
    }
    return formDetail;
}
export function compareBy(key) {
    return function (a, b) {
        let avalue = a[key];
        let bvalue = b[key];
        if (avalue < bvalue) return -1;
        if (avalue > bvalue) return 1;
        return 0;
    };
}

export async function getListFields (fieldDetails, viewFieldorders) {
    let fieldOrders = await getFieldOrdersList(viewFieldorders);
    let fieldSorting = await getFieldSortingList(viewFieldorders);
    let listViewFields = [];
    let viewFields = [];
    for(let fo = 0; fo < fieldOrders.length; fo++) {
        let tempFieldOrder = fieldOrders[fo];
        for (let fi = 0; fi < fieldDetails.length; fi++) {
            let field = fieldDetails[fi];
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            if(fieldType === "reference_entityid"){
                continue;
            }
            let fieldOrder = field[22];
            if (tempFieldOrder === fieldOrder) {
                viewFields.push(field);
            }
        }
    }
    listViewFields.push(viewFields);
    listViewFields.push(fieldSorting);
    return listViewFields;
}

export async function getFieldOrdersList(viewFieldorders) {
    let viewFieldorderArr = viewFieldorders.split(",");
    let fieldOrderArr = [];
    for(let i = 1; i < viewFieldorderArr.length ; i = i + 2) {
        fieldOrderArr.push(viewFieldorderArr [i - 1]);
    }
    return fieldOrderArr;
}

export async function getFieldSortingList(viewFieldorders) {
    let viewFieldorderArr = viewFieldorders.split(",");
    let fieldSortingArr = [];
    for(let i = 1; i < viewFieldorderArr.length ; i = i + 2) {
        fieldSortingArr.push(viewFieldorderArr [i]);
    }
    return fieldSortingArr;
}

export async function getGeneralSettings(key,refresh=false) {
//alert("KEY: "+key);
    let settings = {};
    let response = "";
    let generalSettings = getSessionValue('generalSettings');

    if(generalSettings !== "" && !refresh){
        try{
            settings = parseJSON(generalSettings);
        }catch (e) {}
    }else{
//alert("KEY: "+key);
        //update general settings if not found in session.
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_GENERALSETTINGS"
        }
        let responseData = await requestApi.processServerRequest(params);

        if(responseData.issuccess){
            let Gresponse = responseData.data;
            for(let i in Gresponse){
                settings[Gresponse[i][1]] = Gresponse[i][2];
            }
            setSessionValue('generalSettings',JSON.stringify(settings));
        }else{
            handleErrorResponse(responseData.errormsg);
        }
    }
//alert("KEYVALUE: "+JSON.stringify(settings[key]));
    if(settings[key] !== undefined){
        response = settings[key];
    }

    return response;
}
export async function getWAAnalyticsDetails(refresh=false) {
let response = {};
let params = {
    "ENTITY": "WHATSAPPPROCESS",
    "OPERATION": "GET_WAANALYTICS_DETAILS",
}
let responseData = await requestApi.processServerRequest(params);

if(responseData.issuccess && responseData.data !== undefined){
    response = responseData.data;
}else{

}
return response;

}
export async function getWhatsAppSettings(refresh=false) {
    let response = {};
    let account_id = "";
    let whatsAppSettings = getSessionValue('whatsAppSettings');
    if(whatsAppSettings != undefined || whatsAppSettings != ""){
        let whatsappSettingsArray = parseJSON(whatsAppSettings);
        if(whatsappSettingsArray.length > 0){
            account_id = whatsappSettingsArray[0][0].account_id;
        }
    } 
    if(whatsAppSettings !== undefined && whatsAppSettings !== "" && !refresh && account_id !== undefined && account_id !== ""){
        try{
            response = parseJSON(whatsAppSettings);
        }catch (e) {
        }
    }else{
        //update general settings if not found in session.
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_WHATSAPP_SETTINGS",
        }
        let responseData = await requestApi.processServerRequest(params);
        if(responseData.issuccess && responseData.data !== undefined){
            response = responseData.data;
            setSessionValue('whatsAppSettings',JSON.stringify(response));
        }else{
            if(responseData.errormsg !== "") {
                handleErrorResponse(responseData.errormsg);
            }
        }
    }
    return response;
}

export function unicodeToChar (text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
}

export function emojiToUnicode(text) {
    let unicode = text;
    const regex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
    unicode = unicode.replace(regex, (match) => {
        const codePoint = match.codePointAt(0).toString(16);
        return "\\u{" + codePoint + "}";
    });
    return unicode;
}
function isBase64(str) {
    if (typeof str !== 'string') {
        return false;
    }
    const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*?(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
    return base64Regex.test(str);
}

// export function decodeString(text,parsejson=false){
//     let response = text;
//     try{
//         text = base64_decode(text);
//         response = unicodeToChar(text);

//         if(parsejson){
//             response = parseJSON(response);
//         }

//     }catch (e) {
//         console.log("Error : ",e);
//         console.log("decodeString : ",text);
//     }
//     return response;
// }
export function decodeString(text, parsejson = false) {
    let response = text;
    try {
        if (!isBase64(text)) {
            throw new Error("Input is not a valid Base64 string");
        }
        text = base64_decode(text);
        response = unicodeToChar(text);

        if (parsejson) {
            response = parseJSON(response);
        }
    } catch (e) {
        console.error("Error: ", e.message);
        console.error("decodeString: ", text);
    }
    return response;
}

export function encodeString(text){
    let response = text;
    try {
        response = base64_encode(text);
    }catch (e) {}
    return response;
}

export function removeLastChar(str){
    let response = str;
    try {
        response = str.length > 0 ? str.substring(0, str.length - 1) : str;
    }catch (e) {}
    return response;
}

export function parseJSON(str){
    let res = {};
    try{
        if(str != "" && str != null){
            res = JSON.parse(str);
            if(typeof res === 'string'){
                res = JSON.parse(res);
            }
        }
    }catch (e) {
        //console.log(e);
    }
    return res;
}

export function handleErrorResponse(message){
    if(message.trim() !== "") {
        showToast(message, 'top-right', "error");
    }
}

export function convertDateToUtc(value){
    if(!value instanceof Date){
        value = new Date(value);
    }
    return new Date(`${value}Z`)
}

export async function populateCurrentFormDetail(props,formDetail,formname){
    formDetail = await getFormDetails(formname,props['formDetails']);

    if(formDetail.length === 0){
        formDetail = await populateFormDetails(formname);
        let newFormDetails = {};
        newFormDetails[formname] = formDetail;
        await setFormDetails([newFormDetails]);
    }

    return formDetail;
}

export async function getTemplatesFormDetails(formDetail,templateName="") {

    let selectedTemplate = '';
    let templates = [];

    if(formDetail && formDetail.length > 0) {
        templates = formDetail[4];
        let lastTemplate = formDetail[8].length > 0 ? formDetail[8][0] : [];
        let lastSelectedTemplateId = lastTemplate.length > 0 ? lastTemplate[2] : '';
        for (let key in templates){
            let template = templates[key];

            if(templateName !== ""){
                if(templateName === template[1]){
                    selectedTemplate = template;
                }
            }else{
                if(lastSelectedTemplateId === template[0]){
                    selectedTemplate = template;
                } else if (lastSelectedTemplateId === ""){
                    lastSelectedTemplateId = template[0];
                    selectedTemplate = template;
                }
            }
        }
    }

    return { selectedTemplate, templates }
};

export async function loadFormData(issearch=false,formname,formDetail,selectedTemplate,state,advancedSearch=false){

    let formData = [];
    let rowData = [];
    let listFields = [];
    let totalCount = 0;

    try{
        if(formDetail.length > 0) {
            let template = selectedTemplate;
            let formInfo = formDetail[0];
            let fieldDetails = formDetail[1];
            let moduleName = formInfo[0];
            let templateFieldOrders = template[4];
            let { searchTxt, limit, page } = state;
            let searchStr = '';

            let params = {
                "ENTITY": "Search_by_filter",
                "FORMNAME": formname,
                "RECORDVALUES": limit,
                "MODULENAME" : moduleName,
                "FORMTYPE" : "",
                "Template name" :template[1],
                "Template Id" : template[0],
                "PAGENUMBER" : page,
                "NUMBEROFROW" : limit,
                "isOtherApiReq" : true,
                "isotherapi" : true,
                "ISAPIREQ" : true,
                "predefinedCondition" : ""
            }

            if(issearch || searchTxt !== ''){

                for(let searchindex in searchTxt){
                    if(searchTxt[searchindex] !== ''){
                        searchStr = searchTxt[searchindex];
                    }
                }

                if(searchStr !== ''){
                    params = {
                        'ENTITY' : "Search form",
                        'FORMNAME' : formname,
                        'SEARCHFIELDS' : searchStr,
                        "PREDEFINED":"",
                        "PAGENUMBER":page,
                        "NUMBEROFROW" : limit,
                        "isOtherApiReq" : true,
                        "isotherapi" : true,
                        "ISAPIREQ" : true,
                    }
                }else{
                    params['OPERATION'] = "FIND";
                    params['Template name'] = template[1];
                    params['Template Id'] = template[0];
                }
            }else{
                params['OPERATION'] = "FIND";
                params['Template name'] = template[1];
                params['Template Id'] = template[0];
            }

            let response = await requestApi.processServerRequest(params);

            if(response.issuccess){
                formData = response.data;
                if(searchStr !== ""){
                    formData = formData[0][2];
                }
                totalCount = formData[1];
                rowData = formData[2];
                listFields = await getListFields(fieldDetails, templateFieldOrders);
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }catch (e) {

    }

    return { rowData , listFields, totalCount }
}

export async function loadCustomCampaignandAutomationDate(formname,state,advancedSearch=false){
    let formData = [];
    let datevalues = '';
    try{
    let searchStr = '';
    let { searchTxt , filterTxt, dateFilter, limit, page,filterType,filterId, customCondition } = state;

    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "GET_CAMPAIGN_AUTOMATION_ANALYTICSDATES",
        "FORMNAME": formname,
        "PAGENUMBER" : page,
        "NUMBEROFROW" : limit,
        "isOtherApiReq" : true,
    }
    for(let dateindex in dateFilter){
        if (dateFilter[dateindex] !== '' && dateFilter[dateindex] != null) {
            searchStr = `${searchStr}date@${formname}@${dateindex}@Custom@${formatDate(dateFilter[dateindex][0], "yyyy-mm-dd")}|${formatDate(dateFilter[dateindex][1], "yyyy-mm-dd")}@AND#`;
        }
    }

    if(searchStr !== ''){
        params['SEARCHFIELDS'] = {"advanced_search_key":searchStr, "STARTC":"true"};
    }
    if(filterType !== undefined && filterType !== ""){
        params['customCondition'] = filterType+"#"+filterId;
    }else if(customCondition !== undefined && customCondition !== ""){
        params['customCondition'] = customCondition;
    }
    let response = await requestApi.processServerRequest(params, "Mobile","get",false);
    if(response.issuccess){
        formData = response.data;
        datevalues = formData[0];
    }else{
        handleErrorResponse(response.errormsg);
    }
}catch (e) {

}

return { datevalues }

}

export async function loadCustomFormData(issearch=false,formname,state,advancedSearch=false){

    let formData = [];
    let rowData = [];
    let listFields = [];
    let totalCount = 0;
    let otherInfo = [];

    try{
        let searchStr = '';
        let { searchTxt , filterTxt, dateFilter, limit, page,filterType,filterId, customCondition , status} = state;

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_FORMDATA",
            "FORMNAME": formname,
            "PAGENUMBER" : page,
            "NUMBEROFROW" : limit,
            "isOtherApiReq" : true,
            "predefinedCondition" : "",
            "status": status,
            
        }

        if(!advancedSearch  && (issearch || searchTxt !== '' || filterTxt.length > 0 || dateFilter.length > 0)){
            
            searchStr = await prepareSearchTxt(searchStr, searchTxt, formname);
            searchStr = await prepareSearchString(searchStr, filterTxt, formname);
            searchStr = await prepareSearchDate(searchStr, dateFilter, formname);
            if(filterTxt?.Status === "delivered" || filterTxt?.Status === "read") {
                params['status'] = filterTxt.Status;
            }
            if(searchStr !== ''){
                params['SEARCHFIELDS'] = {"advanced_search_key":searchStr, "STARTC":"true"};
            }
        }else if(advancedSearch){
            params['SEARCHFIELDS'] = state.advancedSearch;
        }

        if(filterType !== undefined && filterType !== ""){
            params['customCondition'] = filterType+"#"+filterId;
        }else if(customCondition !== undefined && customCondition !== ""){
            params['customCondition'] = customCondition;
        }

        let response = await requestApi.processServerRequest(params, "WebV2","get",false);

        if(response.issuccess){
            formData = response.data;
            totalCount = formData[1];
            rowData = formData[2];
            listFields = formData[3];
            otherInfo = formData[4];
        }else{
            handleErrorResponse(response.errormsg);
        }
    }catch (e) {

    }

    return { rowData , listFields, totalCount, otherInfo }
}

export async function processSelectList(filterTxt,name,selectedOptions, isMultiple = false){
    let selectedList = '';

    if(selectedOptions !== undefined && selectedOptions !== null){

        if(isMultiple){
            for(let i in selectedOptions){
                selectedList += selectedOptions[i].value+",";
            }
            selectedList = removeLastChar(selectedList);
        }else{
            selectedList = selectedOptions.value;
        }

        filterTxt[name] = selectedList;
    }else{
        filterTxt[name] = '';
    }

    return  filterTxt ;
}
export function getWABodyVariables(bodyText){
        let variables = [];
        let pattern = /{{\s*(\d+)\s*}}/g;
        let match;
        while (match = pattern.exec(bodyText)){
            variables.push(match[1].trim());
        }
        return [...new Set(variables)];
}

export function normalizeTemplateVariables(htmlContent) {
    if (!htmlContent) return htmlContent;
    let variables = getWABodyVariables(htmlContent);
    let uniqueVars = [...new Set(variables)]
        .map(v => parseInt(v, 10))
        .filter(n => !isNaN(n))
        .sort((a, b) => a - b);
        
    let needsNormalization = false;
    for (let i = 0; i < uniqueVars.length; i++) {
        if (uniqueVars[i] !== i + 1) {
            needsNormalization = true;
            break;
        }
    }
    
    if (needsNormalization) {
        let newContent = htmlContent;
        uniqueVars.forEach((variable, index) => {
            let targetVar = index + 1;
            if (variable !== targetVar) {
                let varRegex = new RegExp(`\\{\\{\\s*${variable}\\s*\\}\\}`, 'g');
                newContent = newContent.replace(varRegex, `{{${targetVar}}}`);
            }
        });
        return newContent;
    }
    return htmlContent;
}

/**
 * Replace symbols with html elements
 * @param {String}  symbol       - character to replace with html element
 * @param {Array}   element      - Html elements to replace symbols
 * @param {String}  text         - text content to perform replace operation
 * @param {Boolean} [parseStr=0] - optional param to parse string html elements to html format
 * @return {String}
 */
export function replaceSymbols(symbol,element,text,parseStr=false){

    try{
        let boldString = [...element];
        let boldStringIndex = 0;
        let textLength = 0;

        if(text !== undefined && text !== ''){
            let replacedString = "";
            if(text.includes(symbol)){
                text = text.split(symbol);
                textLength = text.length;
                for(let i=0; +i< +textLength; i++){
                    if( (i === textLength - 1) && (boldStringIndex === 0)){
                        replacedString = replacedString + text[i];
                    }else{
                        replacedString = replacedString + text[i]+boldString[boldStringIndex];
                        boldStringIndex = (boldStringIndex === 0) ? 1 : 0;
                    }
                }
                text = replacedString;
            }
        }

        if(parseStr){
            try {
                text = parseHtml(text);
            }catch (e) {}
        }
    }catch (e) {}

    return text;
}
export function isCharacterRepeated(str, char) {
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === char) {
      count++;
    }
  }
  return count > 1 || (count === 1 && str[0] === char && str[str.length - 1] === char);
}

export function isHtmlContent(content) {
    // Create a DOM parser
    const parser = new DOMParser();
    // Parse the string as HTML
    const doc = parser.parseFromString(content, 'text/html');
    // Check if the content contains valid HTML tags
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); // Node.ELEMENT_NODE
}

export function replaceSymbolsToHtml(text,parsehtml = true){
    const skipReplaceStar = isCharacterRepeated(text,'*');
    const skipReplaceunderscore = isCharacterRepeated(text,'_');
    const skipReplacetilde = isCharacterRepeated(text,'~');
    const skipReplacebacktick = isCharacterRepeated(text,'`');
    if(!isHtmlContent(text)){
        text = text.replaceAll("<", "< ");
    }
    if(skipReplaceStar){
    text = replaceSymbols('*',["<strong> "," </strong>"],text);}
    if(skipReplaceunderscore){
    text = replaceSymbols('_',["<em> "," </em>"],text);}
    if(skipReplacetilde){
    text = replaceSymbols('~',["<del> "," </del>"],text);}
    if(skipReplacebacktick){
    text = replaceSymbols('`',["<code> "," </code>"],text);}
    if(parsehtml){
        text = replaceLinks(text);
        try{
            text = parseHtml(text);

        }catch (e) {}
    }

    return text;
}

export function replaceHtmlToString(str){
    try {
        str = str
            .replace(/<p>/g, '')
            .replace(/<\/p>/g, '')
            .replace(/&nbsp;/g, ' ')
            .replace(/<strong>/g, '*')
            .replace(/<\/strong>/g, '*')
            .replace(/<em>/g, '_')
            .replace(/<\/em>/g, '_')
            .replace(/<del>/g, '~')
            .replace(/<\/del>/g, '~')
            .replace(/<br>/g, '\n')
            .replace(/<br\/>/g, '\n');

        str = str.toString().replace(/<[^>]+>/g, '');
        str = decodeHtml(str);
    }catch (e) {}
     return str;
}

export function decodeHtml(html) {
    try {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        html =  txt.value;
    }catch (e) {}

    return html;
}

export function trimSpaces(text) {
    const symbols = ['*', '_', '~'];

    symbols.forEach(symbol => {
        const regex = new RegExp(`\\${symbol}([^\\${symbol}]+)\\${symbol}`, 'g');
        text = text.replace(regex, (match, p1) => {

            let trimmedString = `${symbol}${p1.trim()}${symbol}`;

            for (let i = 0; i < p1.length; i++) {
                if (p1.charAt(i) === ' ') {
                    trimmedString = ' ' + trimmedString;
                } else break;
            }
            for (let i = p1.length - 1; i >= 0; i--) {
                if (p1.charAt(i) === ' '){
                    trimmedString = trimmedString+' ';
                } else break;
            }

           return trimmedString;
        });
    });

    return text;
}

export function replaceStringTohtml(str){

    let html = "";
    let lines = str.split("\n");
    str = str.replace(/\n/g,'<br/>');

    /*for(let key in lines){
        if(lines[key] !== ""){
            if(key > 0){
                html += `<p>${lines[key]}</p>`;
            } else {
                html += `<p>${lines[key]}</p><br/>`;
            }

        }
    }*/

    html = str.replace(/ /g, '&nbsp;');
    html = replaceSymbolsToHtml(html,false);

    return html;
}
export function replaceBetweenSpaceTags(str){
    let result = str.replace(/<\s*(\/?\w+)(\s*[^>]*)\s*>/g, "<$1$2>");
    return result;
}


export function replaceLinks(text) {

    let replacedText = text;

    try{
        const links = getLinks(text);
        const processed = new Set(); // store processed link.value

        for (const link of links) {
             // Skip if already processed
            if (processed.has(link.value)) {
                continue;
            }
            processed.add(link.value);
            const regex = new RegExp(link.value, 'g');
            if((link.type === 'url')||(link.type === 'emailid')||(link.type === 'phoneno' /*&& (link.value.length === 10)*/)){
                replacedText = replacedText.replace(regex, `<a target='_blank' className='chat__linktext' href="${link.href}">${link.value}</a>&nbsp;`);
            }
        }
    }catch (e) {}

    return replacedText;
}

export function getLinks(text) {
    // Use regex to identify url, email, and phone number values in the text
    //const urlRegex = /(https?:\/\/[^\s\/]+(\/\S+)?)/g;
    const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;
                 //  /(https?:\/\/[^\s()]+)/g;
    const emailRegex = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}(;|$))/g;
                    // /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g;
    //const phoneRegex = /(\d{10,16})/g;
    const phoneRegex = /(^(\+\d{1,3}[- ]?)?\d{10,16}$)/g;

    // Create an array of objects containing the identified values and their corresponding href values
    const links = [];
    let match;
    while ((match = urlRegex.exec(text)) !== null) {
        links.push({
            value: match[1],
            href: match[1],
            type: 'url'
        });
    }
    while ((match = emailRegex.exec(text)) !== null) {
        links.push({
            value: match[1],
            href: 'mailto:' + match[1],
            type: 'emailid'
        });
    }
    while ((match = phoneRegex.exec(text)) !== null) {
        links.push({
            value: match[1],
            href: 'tel:' + match[1],
            type: 'phoneno'
        });
    }

    return links;
}

export async function getFormData(formname, formDetail, selectedTemplate, limit, page, advancedSearch= {}){
        let template = selectedTemplate;
        let formInfo = formDetail[0];
        let fieldDetails = formDetail[1];
        let moduleName = formInfo[0];
        let templateFieldOrders = template[4];
        let params = {
                "ENTITY": "FORMPROCESS",
                "OPERATION": "FIND",
                "FORMNAME": formname,
                "RECORDVALUES": limit,
                "MODULENAME" : moduleName,
                "SEARCHFIELDS" : advancedSearch,
                "FORMTYPE" : "",
                "LASTSELECTEDTEMPLATE" : template[0],
                "PAGENUMBER" : page,
                "NUMBEROFROW" : limit,
                "isOtherApiReq" : true,
        }
        let formresponse = await requestApi.processServerRequest(params, "Mobile");
        return formresponse;
}

export async function getAccessedFormsFromProfile(tabList =[]){
    let currentUserId = getSessionValue('loginuserid');
    let tagList = "table_6,table_21,table_38";
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "GET_PROFILEACCESS_ENABLED_FORMS",
        "userid": currentUserId,
        "isOtherApiReq" : true,
        "tagList" : tabList,
    };
    
    let tablists = await requestApi.processServerRequest(params);
    return tablists;
}

export async function getFormInformation(formId, formname){
        let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "GET_FORM_RECORD",
                "FORMNAME": formname,
                "FORMID": formId,
                "ISAPIREQ" : true,
                }
        let formResponse = await requestApi.processServerRequest(params, "WebV2");
        return formResponse;
}

export async function getConnectionStatus(){
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "WP_CONNECTION_STATUS",
    }
    let response = await requestApi.processServerRequest(params, "WebV2");
    return response;
}

export function getWAComponents(components){
        let waComponents = {};
     try{ 
        if(components !== "" && components !== undefined){
            components.map((component) => {
                let cType = component['type'];
                waComponents[cType] = component;
            });
        }
        return waComponents;
    }catch(e){
        console.log("Dbug Error : ",e);
        console.log("getWAComponents : ",components);
    }
}

export async function getTemplateInfo (templateInfo) {
    let template = {};

    if(templateInfo !== undefined && templateInfo !== "" && templateInfo != null){
        let templateArr = templateInfo.split("#");
        template = {
            value : templateArr[0],
            label : templateArr[1]
        }
    }

    return template;
}

export async function loadContactsData(filterOption = "", page = 1, limit = 200, method = "", cid = ""){
    const contactForm = process.env.REACT_APP_CONTACT_FORMNAME;
    const templateForm = process.env.REACT_APP_CONVERSATION_FORMNAME;

    filterOption = JSON.stringify(filterOption);
    if(filterOption !== "" && filterOption == '{}'){
        filterOption = "";
    }

    setSessionValue("FILTEROPTION" , filterOption);
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "loadContacts",
        "FORMNAME": contactForm,
        "TEMPLATE_FORMNAME": templateForm,
        "FILTEROPTION" : filterOption,
        "isOtherApiReq" : true,
        "PAGE" : page,
        "LIMIT" : limit,
        "METHOD" : method,
        "CONTACTID" : cid,
    }
    let response = await requestApi.processServerRequest(params, "Mobile");
    return response;
}

export async function resetUnreadCount(leadid){
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "RESET_UNREAD_MSG",
        "CONTACTID" : leadid,
        "isOtherApiReq" : true,
    }
    let response = await requestApi.processServerRequest(params, "Mobile","post");
    return response;
}

export function extractDisplayMessage(type,component,jsoninfo,decode=false){

    let response = {type: "",content: "", format : "", bodyText : false};

    if(decode){
        component = parseJSON(decodeString(component));
        jsoninfo = parseJSON(decodeString(jsoninfo));
    }

    //Message sent from application
    if(type === 'Out'){
        if(jsoninfo['type'] !== undefined){

            let content = "";
            let contentType = jsoninfo['type'];
            let link = '';

            if(contentType === 'template'){

                let headerContent = "";
                let bodyContent = "";
                let format = "";
                //Extract text content from template
                if(component !== "" && component !== null){
                    for(let key in component){
                        //Extract text from header content
                        if(component[key]['type'] === 'HEADER'){
                            format = component[key]['format'].toLowerCase();
                            if(component[key]['format'] === 'TEXT'){
                                headerContent = headerContent+ component[key]['text'];
                            }
                        //Extract text from body content
                        }else if(component[key]['type'] === 'BODY'){
                            bodyContent = bodyContent+ component[key]['text'];
                        }else if(component[key]['type'] === 'CAROUSEL' || component[key]['type'] === 'carousel'){ 
                            format = 'CAROUSEL';
                        }
                    }
                    let replacedContent = [];
                    replacedContent = constructTemplateMsgFromApp(replacedContent,jsoninfo);
                    content = replaceVariableContent(replacedContent,headerContent,bodyContent);
                }

                if(content === ""){
                    content = contentType;
                }
                response = {type: contentType, content: content,format:format, bodyText: bodyContent.length > 0 };
            }else if(contentType === 'text'){
                response = {type: contentType, content: jsoninfo['text']['body'], bodyText: true};
            }else if(contentType === 'interactive'){
                let bodyText = (jsoninfo[contentType]['body'] !== undefined && jsoninfo[contentType]['body']['text'] !== undefined) ?
                    jsoninfo[contentType]['body']['text'] : "";
                response = {type: contentType, content: bodyText, bodyText: (bodyText !== "")}
            }else{
                if(jsoninfo[contentType]['caption'] !== undefined){
                    content = jsoninfo[contentType]['caption'];
                }else if(jsoninfo[contentType]['filename'] !== undefined){
                    content = jsoninfo[contentType]['filename'];
                }else{
                    content = contentType;
                }

                if(jsoninfo[contentType]['link'] !== undefined){
                    link = jsoninfo[contentType]['link'];
                }
                response = {type: contentType, content: content, link: link, bodyText: (contentType === "audio" || contentType === "document") ? true : false};
            }
        }
    //Message sent from user
    }else{
        let repliedMessage = {};

        try{
            let bussinessData = {};

            if(jsoninfo['entry'][0]['changes'][0]['value']['messaging_product'] !== undefined){
                bussinessData = jsoninfo['entry'][0]['changes'][0]['value'];
            }else {
                bussinessData = jsoninfo['entry'][0]['changes'][0]['value']['whatsapp_business_api_data'];
            }
            repliedMessage = bussinessData['messages'][0];
        }catch (e) {}

        if(Object.keys(repliedMessage).length > 0){
            if(repliedMessage['type'] !== undefined){
                let contentType = repliedMessage['type'];
                if(repliedMessage[contentType] !== undefined){
                    let content = contentType;
                    let link = '';
                    let bodyTextContent = false;
                    if(contentType === 'interactive'){
                        let interactiveType = repliedMessage[contentType]['type'];
                        content = repliedMessage[contentType][interactiveType] !== undefined && repliedMessage[contentType][interactiveType]['title'] !== undefined ?
                            repliedMessage[contentType][interactiveType]['title'] : "";
                        bodyTextContent = true;
                    }else if(contentType !== 'text'){
                        if(repliedMessage[contentType]['caption'] !== undefined){
                            content = repliedMessage[contentType]['caption'];
                        }else if(repliedMessage[contentType]['filename'] !== undefined){
                            content = repliedMessage[contentType]['filename'];
                        }
                        if(repliedMessage[contentType]['link']){
                            link = repliedMessage[contentType]['link'];
                        }
                    }else{
                        content = repliedMessage[contentType]['body'];
                        bodyTextContent = true;
                    }
                    if(contentType === "button"){
                        bodyTextContent = true;
                    }
                    bodyTextContent = true;
                    response = {type: contentType, content: content, link : link, bodyText: bodyTextContent};
                }
            }
        }
    }

    return response;
}

export function replaceVariableContent(replace,headerContent,bodyContent){
    const defaultBodyValuePrefix = "body_df_value_field_";
    const defaultHeaderValuePrefix = "header_df_value_field_";

    if(headerContent.includes('{{1}}') && replace[defaultHeaderValuePrefix+'1'] !== undefined){
        headerContent = headerContent.replace('{{1}}',replace[defaultHeaderValuePrefix+'1']);
    }

    if(bodyContent !== ""){
        let variables = getWABodyVariables(bodyContent);
        for(let i=1;i<=variables.length;i++){
            if(bodyContent.includes('{{'+i+'}}') && replace[defaultBodyValuePrefix+i] !== undefined){
                bodyContent = bodyContent.replace('{{'+i+'}}',replace[defaultBodyValuePrefix+i]);
            }
        }
    }

    return headerContent+" "+bodyContent;
}

export function constructTemplateMsgFromApp(replacedContent,jsonInfo) {

    let jsonParams = [];
    let contentType = '';
    const defaultBodyValuePrefix = "body_df_value_field_";
    const defaultHeaderValuePrefix = "header_df_value_field_";

    if(jsonInfo['template'] !== undefined && jsonInfo['template']['components'] !== undefined && Object.keys(jsonInfo['template']['components']).length > 0){
        //Get actual parameters for body variables.
        jsonParams = getWAComponents(jsonInfo['template']['components']);
        if(jsonParams['body'] != undefined && jsonParams['body']['parameters'] != undefined){
            for(let i in jsonParams['body']['parameters']){
                replacedContent[defaultBodyValuePrefix + ( +i + 1)] =  jsonParams['body']['parameters'][i]['text'];
            }
        }

        //Get actual parameters for variables and media in header.
        if(jsonParams['header'] !== undefined && jsonParams['header']['parameters'] !== undefined && jsonParams['header']['parameters'][0] !== undefined){
            let params = jsonParams['header']['parameters'];
            contentType = params[0]['type'];

            if(contentType === 'text'){
                if(params[0][contentType] !== undefined){
                    replacedContent[defaultHeaderValuePrefix + '1'] = params[0][contentType];
                }
            }else {
                if(params[0][contentType]['link'] !== undefined){
                    replacedContent['mediaUrl'] = params[0][contentType]['link'];
                }
            }
        }

        // Get actual parameters for Carousel.
        if (jsonParams['carousel'] !== undefined && jsonParams['carousel']['cards'] !== undefined) {
             let cards = jsonParams['carousel']['cards'];
             cards.forEach((card, i) => {
                  let cardIndex = card['card_index'] !== undefined ? card['card_index'] : i;
                  if (card['components']) {
                      card['components'].forEach(comp => {
                           if (comp.type === 'header') {
                                let params = comp['parameters'];
                                if (params && params[0]) {
                                    let type = params[0]['type']; 
                                    if (params[0][type] && params[0][type]['link']) {
                                        replacedContent[`carousel_card_${cardIndex}_mediaUrl`] = params[0][type]['link'];
                                    }
                                }
                           }
                      });
                  }
             });
        }
    }

    return replacedContent;
};

export function randstr(prefix)
{
    return Math.random().toString(36).replace('0.',prefix || '');
}

export function randomNumber(){
    return Math.floor(Math.random()*(999-100+1)+100);
}

export function getLeadFieldName(field){

    let leadformname = getSessionValue('leadformname');

    if(field === 'contactname'){
        return leadformname === 'table_236' ? 'Contact_Name' : 'Contact';
    }else if(field === 'mobile'){
        return leadformname === 'table_236' ? 'Mobile' : 'Mobile Number';
    }else if(field === 'emailAddress'){
        return leadformname === 'table_236' ? 'Email' : 'Email Address';
    }else if(field === 'id'){
        return leadformname === 'table_236' ? 'table_236_id' : 'table_201_id';
    }

    return '';
}

export function getOpenChatCount(contacts){

    let openCount = 0;

    if(contacts !== undefined && contacts !== null){
        for(let key in contacts){
            if(contacts[key]['wsapp_convo_status'] !== undefined){
                if(contacts[key]['wsapp_convo_status'] !== 'Closed'){
                    openCount++;
                }
            }
        }
    }

    if(+openCount > 99) {
        openCount = '99+';
    }

    //Update Title manually
    document.title = `Cratio - Inbox (${openCount})`;

    return openCount;
}

export function updateWpConnectionMode(mode){
    setSessionValue('wpConnectionMode',mode);
}

export function updateWpConnectionError(status){
    setSessionValue('wpConnectionError',status);
}

export function getWpConnectionErrorStatus(){
    return getSessionValue('wpConnectionError');
}

export function getLicenseErrorStatus(){
    return getSessionValue('licenseError');
}

export function getLicenseErrorMsg() {
    return getSessionValue('licenseErrorMsg');
}

export async function getWhatsAppConnectionMethod(){
    let response = await getConnectionStatus();
    let connection = "";
    if(response.issuccess) {
        let data = response.data;
        connection = data['connection'];
    }

    return connection;
}

export async function getHeaderNotification(){

    let notification = {
        show : false,
        text : "",
        icon : true,
        btnShow : false,
        btnText : "",
    }

    let wpConnectionMode = getSessionValue('wpConnectionMode');
    let isWpConnectionError = getWpConnectionErrorStatus();
    let licenseErrorStatus = getLicenseErrorStatus();
    let licenseErrorMsg = getLicenseErrorMsg();
    let downloadPIBtn = parseJSON(getSessionValue('downloadPIBtn'));
    if(downloadPIBtn !== null && downloadPIBtn !== ""){
        notification.btnShow = downloadPIBtn.showBtn;
        notification.btnText = downloadPIBtn.btnLable;
    }
    //get current whatsapp connection type from db when its not available in session.
    if(wpConnectionMode === "" || wpConnectionMode === null){
        wpConnectionMode = await getWhatsAppConnectionMethod();
        updateWpConnectionMode(wpConnectionMode);
    }

    //update value in session if it's empty.
    if(isWpConnectionError === "" || isWpConnectionError === null){
        //test api status and update session based on that.
        //await whatsappApi.getTemplates();
        //Getting status again to check whether anything went wrong on above test action.
        isWpConnectionError = getWpConnectionErrorStatus();
        if(isWpConnectionError === "" || isWpConnectionError === null){
            isWpConnectionError = 'false';
            updateWpConnectionError(isWpConnectionError);
        }
    }

    if(licenseErrorStatus === 'true' || licenseErrorMsg !== ""){ //show nofitfication when License has expired.
        notification.show = true;
            //notification.text = parseHtml("<p className=\"notification-text\">Action Needed! Your CRM account subscription has expired. Please subscribe to a plan to continue using your account.</p>");
        notification.text = parseHtml("<p className=\"notification-text\">"+licenseErrorMsg+"</p>");

        const curURL = window.location.href;
        if(curURL && (curURL.includes(`/#/subscription`))){
            notification.show = false;
        }

    }else if(wpConnectionMode === 'sandbox'){ //show nofitfication when it's sandbox mode.
        //notification.show = true;
        //notification.text = parseHtml("<p className=\"notification-text\">Your account is currently in test mode. To Connect your WhatsApp Business API</p><span className=\"header-notification-actions\"><a href='/#/settings/whatsapp' className=\"header-notification-button\">Click Here</a></span>");
    }else if(isWpConnectionError === 'true'){ //show notification when Error connecting to Api
        //notification.show = true;
        //notification.text = parseHtml("<p className=\"notification-text\">Action Required! It seems your WhatsApp Business API is not connected.</p><span className=\"header-notification-actions\"><a href='/#/settings/whatsapp' className=\"header-notification-button\">Click Here</a></span><p className=\"notification-text\" > to reconnect.</p>");
    }

    /** <p className="notification-text">
            {notification.text}
        </p>
        <span className={`header-notification-actions`}>
                            {notification.button && <Link to={notification.buttonlink} className={`header-notification-button`}>{notification.buttontext}</Link>}
            {notification.link && <a target='_blank' href={notification.linkurl} className={`header-notification-url`}>{notification.linktext}</a>}
                        </span>
    **/
    return notification;
}

export async function validateRestrictedActions(){

    let response = true;

    //Don't allow to Create/Update Automation on sandbox mode.
    let wpConnectionMode = getSessionValue('wpConnectionMode');
    if(wpConnectionMode === 'sandbox'){
        showToast('Your account is currently in test mode. Please connect your WhatsApp Business API account to perfrom this action.','top-right','error');
        response = false;
    }

    //Don't allow to create/update Automation on Api Error.
    let isWpConnectionError = getWpConnectionErrorStatus();
    if(isWpConnectionError === 'true'){
        showToast('Action Required! It seems your WhatsApp Business API is not working. Please re-connect your WhatsApp Business API account to perfrom this action.','top-right','error');
        response = false;
    }

    //Don't allow to create/update Automation after License Expired.
    let licenseErrorStatus = getLicenseErrorStatus();
    if(licenseErrorStatus === 'true'){
        showToast('Action Needed! Your CRM account subscription has expired. Please subscribe to a plan to continue using your account.','top-right','error');
        response = false;
    }

    return response;
}


export function getErrorMsg (msg, isInbox = false) {
    let response = '';

    if(msg !== ''){

        if(msg.includes('#')){
            msg = msg.split('#');
            if(errorMessages[msg[0]] !== undefined){
                response = errorMessages[msg[0]];
            }else{
                response = msg[1];
            }
        }else{
            response = msg;
        }
    }else{
        response = "message failed to send.";
    }

    if(response === 'Message undeliverable'){
        response = `Message not delivered.
This can happen if the recipient isn't on WhatsApp or needs to update their app or accept the latest terms.`;
    }else if(response === 'This message was not delivered to maintain healthy ecosystem engagement.'){
            response = `<strong>Meta Template Delivery Blocked</strong>
            <br />
            <br />
            Meta blocked your template message to maintain healthy ecosystem
            engagement.
            <br />
            <br />
            This can happen when:
            <br />
            • Too many marketing templates are sent
            <br />
            • Users are not engaging (low reply rate)
            <br />
            • Users ignore, block, or report messages
            <br />
            • Per-user marketing limit is exceeded
            <br />
            <br />`;
        if(isInbox){
            response += `Please wait at least 24 hours before resending.`;
        }else{
            response += `Please wait at least 24 hours after its retryed automatically.`;
        }
        response = parseHtml(response);
    }

    return response;
}


export async function prepareSearchTxt(searchStr, searchTxt, formname){
    for(let searchindex in searchTxt){
        if(searchTxt[searchindex] !== ''){
            searchStr = `${searchStr}nondate@${formname}@${searchindex}@contains@${searchTxt[searchindex]}@AND#`;
        }
    }
    return searchStr;
}

export async function prepareSearchString(searchStr, filterTxt, formname){
    if (filterTxt && filterTxt.Status === 'replied') {
        filterTxt = { Is_Replied: '1' };
    }
    for(let index in filterTxt){
        if(filterTxt[index] !== ''){
            let filterTxtArr = filterTxt[index].split(",");
            for(let findex in filterTxtArr) {
                if(filterTxtArr[findex] === "All"){
                    searchStr = `${searchStr}nondate@${formname}@${index}@is not empty@empty@AND#`;
                } else {
                    let addonCond = "OR";
                    if(parseInt(findex) === filterTxtArr.length - 1){
                        addonCond = "AND";
                    }
                    searchStr = `${searchStr}nondate@${formname}@${index}@is@${filterTxtArr[findex]}@${addonCond}#`;
                }
            }
        }
    }

    return searchStr;
}

export async function prepareSearchDate(searchStr, dateFilter, formname){
    for(let dateindex in dateFilter){
        if (dateFilter[dateindex] !== '' && dateFilter[dateindex] != null) {
            searchStr = `${searchStr}date@${formname}@${dateindex}@Custom@${formatDate(dateFilter[dateindex][0], "yyyy-mm-dd")}|${formatDate(dateFilter[dateindex][1], "yyyy-mm-dd")}@AND#`;
        }
    }
    return searchStr;
}

export function logoutUser(data){
    let {appid,userid,sessionid} = data;
    let currentAppId = getSessionValue('appid');
    let currentUserId = getSessionValue('loginuserid');
    let currentSessionId = getSessionValue('sessionid');
    if(appid === currentAppId && userid === currentUserId && sessionid === currentSessionId){
        clearSessionValue();
        window.location = getLogoutURL();
    }
}

export async function menuRefresh(data){
    let {appid,userid,profile} = data;
    let currentAppId = getSessionValue('appid');
    let currentProfile = await getProfileName();
    if(currentAppId === appid && profile === currentProfile){
        let params = {
            "ENTITY" : "WHATSAPPPROCESS",
            "OPERATION" : "GETMENUS",
        }
        let response = await requestApi.processServerRequest(params, "WebV2","get", false);
        if(response.issuccess) {
            let menus = response.data;
            setSessionValue('menus', JSON.stringify(menus));
        }
    }
}

export async function syncTemplates(){
    let formname = process.env.REACT_APP_TEMPLATES_FORMNAME;
    // let templates = await whatsappApi.getTemplates();
    // if(templates.message_templates !== undefined && templates.message_templates.data !== undefined && templates.message_templates.data.length > 0){
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "SYNC_WHATSAPP_TEMPLATES",
            "FORMNAME": formname,
            // "TEMPLATES" : templates.message_templates.data
        };
        let response = await requestApi.processServerRequest(params,'WebV2','post');
        if(response.issuccess){
            showToast('Templates synced successfully');
        }else{
            handleErrorResponse(response.errormsg);
        }
    // }else{
    //     handleErrorResponse('Unable to get templates. Try Later!');
    // }
}

export function secondsToHms(d) {
    d = Number(d);

    //var h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    return ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
}

export function getDayNumber(day){
    let dayNumbers = {
        "Mon" : 0,
        "Tue" : 1,
        "Wed" : 2,
        "Thu" : 3,
        "Fri" : 4,
        "Sat" : 5,
        "Sun" : 6,
    };
    return dayNumbers[day];
}
/**
 * Replace component data into (label-value) fromat.
 * @param {Array}    formData     - values will be updated to this field
 * @param {Array}   components    - contains data that will be converted to label-value format
 * @return {String}
 */
export function getFieldValuefromComponent(formData,components){
    let bodyText = formData['Message'] !== undefined ? formData['Message'] : '';
    let variablesIndex = getWABodyVariables(bodyText);
    variablesIndex = variablesIndex.sort();
    if(components !== "" && components !== null && components !== "null"){
        let variables = parseJSON(components);
        for(let v = 0; v < variables.length; v++){
            let variableSelect = variables[v];
            let vIndex = v + 1;
            let tmpSelect = {
                value : variableSelect.value,
                label : variableSelect.label
            }
            let objName = "body_variable_field_"+variablesIndex[v];
            formData[objName+"_selected"] = tmpSelect;
            formData["body_df_value_field_"+variablesIndex[v]] = variableSelect.defaultvalue;
        }
    }
    
    return formData;
}

/**
 * Replace Dynamic Variables with actual lead info.
 * @param {Array}    leadInfo     - contains lead details and replace details
 * @param {String}   message      - Message to replace dynamic data with actual lead info
 * @return {String}
 */
export function replaceVariables(leadInfo,message){

    const defaultBodyVariablePrefix = "body_variable_field_";
    const defaultBodyValuePrefix = "body_df_value_field_";

    let variables = getWABodyVariables(message);
    for(let i=1;i<=variables.length;i++){
        if(message.includes('{{'+i+'}}')){
            //update direct lead values if found in lead

            let fieldLabel = defaultBodyVariablePrefix+i+"_selected";
            let defaultLabel = defaultBodyValuePrefix+i;

            if(
                leadInfo[fieldLabel] !== undefined &&
                leadInfo[fieldLabel].value !== undefined &&
                leadInfo[fieldLabel].value !== "" &&
                leadInfo[leadInfo[fieldLabel].value] !== undefined &&
                leadInfo[leadInfo[fieldLabel].value] !== ""
            ){
                message = message.replace('{{'+i+'}}',leadInfo[leadInfo[fieldLabel].value]);
            // update default values if data not found in lead
            }else if(leadInfo[defaultLabel] !== undefined && leadInfo[defaultLabel] !== ""){
                message = message.replace('{{'+i+'}}',leadInfo[defaultLabel]);
            // update dynamic info with semi colon if data not found.
            }else{
                message = message.replace('{{'+i+'}}','-');
            }
        }
    }

    return message;
}

/**
 * Returns current user profile name.
 * @return {String}
 */
export async function getProfileName(){
    let profileName = getSessionValue('profilename');

    if(profileName === "" || profileName === null){
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_PROFILE_NAME",
        }
        let response = await requestApi.processServerRequest(params, "Mobile");
        if(response.issuccess){
            profileName = response.data;
            setSessionValue('profilename',profileName);
        }
    }

    return profileName;
}

// export function htmlToDraftBlocks (html) {
//     const blocksFromHtml = htmlToDraft(html);
//     const { contentBlocks, entityMap } = blocksFromHtml;
//     const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
//     return EditorState.createWithContent(contentState);
// }

export async function getProfileFields (){
    let profileFields = getSessionValue('profileFields');

    if(profileFields === undefined ||profileFields === "" || profileFields === null){
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_WAPP_PROFILE_FIELDS",
        }
        let response = await requestApi.processServerRequest(params, "Mobile");
        if(response.issuccess){
            profileFields = response.data;
            if(profileFields !== undefined && profileFields !== "" && profileFields !== null){
                setSessionValue('profileFields',JSON.stringify(profileFields));
                profileFields = parseJSON(profileFields);
            }
        }
    }else{
        profileFields = parseJSON(profileFields);
    }

    return profileFields;
}

export const currencyFormatter = (contryCode = 'en-IN', currency = 'INR', number,minFraction=0) => {

    let res = number;
    try{
        const formatter = new Intl.NumberFormat(contryCode, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: minFraction,
        });
        res = formatter.format(number);

    }catch(e){}

    return res;
}

export async function getPickLists() {
    let params = {
        "ENTITY": "PickList",
        "OPERATION": "GETALL",
    };

    let response = await requestApi.processServerRequest(params,'WebV2','post');
    if(response.issuccess) {
        let pickListMapper = {};
        let allPickLists = response.data;
        for(let i = 0; i < allPickLists.length; i++){
            let pickList = allPickLists[i];
            let picklistName = pickList[0];
            let pickListItems = [];
            for(let j = 4; j < pickList.length; j++){
                pickListItems.push(pickList[j]);
            }
            pickListMapper[picklistName] = pickListItems;
        }
        setSessionValue('picklist_details',JSON.stringify(pickListMapper));
    }
}

export function getPickListItems(listName) {
    let pickListMappers = getSessionValue('picklist_details');
    pickListMappers = parseJSON(pickListMappers);
    if(pickListMappers[listName] === undefined){
        return [];
    }
    let pickList = pickListMappers[listName];
    return pickList;
}

export function prepareDefaultValueList(formdetails){
    let fieldDetails = formdetails[1];
    let dataRow = {};
    fieldDetails.map((fielddetail)=> {
        let fieldName = fielddetail[2];
        let fieldLabel = fielddetail[3];
        let fieldType = fielddetail[4];
        let isConfigHide = parseInt(fielddetail[10]);
        let isViewHide = parseInt(fielddetail[11]);
        let isMandatory = parseInt(fielddetail[16]);
        let defaultValue = fielddetail[19];
        if(fieldType !== "reference_entityid" && fieldType !== "reference_group" && fieldType !== "subtable"){
            if(fieldType === "reference"){
                let refDetail = fielddetail[35];
                let refformname = refDetail[1];
                dataRow[refformname+"_id"] = "";
            } else if (fieldType === "ComboBox"){
                defaultValue = defaultValue.split(",");
                defaultValue = defaultValue[1];
            }
            dataRow[fieldLabel] = defaultValue;
        }

    });
    return dataRow;
}

export function getFieldWidget(fieldDetail, onChange, errors = {}, dataRow = {}, field = {}, fieldAccess = 1){
    if(fieldDetail !== undefined) {
        let fieldType = fieldDetail[4];
        let fieldName = fieldDetail[2];
        let fieldLabel = fieldDetail[3];
        let defaultValue = fieldDetail[19];
        let formName = fieldDetail[1];
        let fLength = fieldDetail[5];
        let attributes = {fieldLabel: fieldLabel, fieldName: fieldName, fieldType : fieldType, formname : formName, fLength : fLength};
        let controls = {maxlength: fLength};
        if(fieldAccess === 0){
            controls['disabled'] = true;
        }
        if (fieldType === "Text") {
            return (
                <CratioTextInput value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if(fieldType === "Email") {
            return (
                <CratioEmailInput value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if(fieldType === "MobileNo") {
            return (
                <CratioMobileInput value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if (fieldType === "Currency") {
            return (
                <CratioCurrencyInput value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if(fieldType === "Int") {
            return (
                <CratioNumberInput value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if(fieldType === "Text Area") {
            return (
                <CratioTextArea value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if (fieldType === "SuggestBox") {
            return (
                <CratioSuggestBox   value={dataRow[fieldLabel]} inputClass={`${errors[fieldName + "_fieldinput"] ? 'is-invalid' : ''}`} onChange={onChange} attributes={attributes} controls={controls} />
            )
        } else if (fieldType === "ComboBox") {
            return (
                <CratioDropdownField
                    value={dataRow[fieldLabel]}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    controls={controls}
                    attributes={attributes}
                />
            )
        } else if (fieldType === "MultiComboBox") {
            let linkUrl = fieldDetail[8];
            attributes['custom_property'] = linkUrl;
            return (
                <CratioDropdownField
                    value={dataRow[fieldLabel]}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    controls={controls}
                    attributes={attributes}
                    isMulti={true}
                />
            )
        } else if (fieldType === "date") {
            return (
                <CratioDatePicker
                    value={dataRow[fieldLabel]}
                    onChangeEvent={onChange}
                    defaultValue={defaultValue}
                    controls={controls}
                    attributes={attributes}
                />
            )
        } else if (fieldType === "Date_Time") {
            return (
                <CratioDateTimePicker
                    value={dataRow[fieldLabel]}
                    onChangeEvent={onChange}
                    defaultValue={defaultValue}
                    controls={controls}
                    attributes={attributes}
                />
            );
        } else if (fieldType === "entity_group" || fieldType === "reference") {
            let refDetails = fieldDetail[35];
            let fieldValue = dataRow[fieldLabel+"_id"];
            if(fieldValue === undefined){
                fieldValue = defaultValue;
            }
            return (
                <CratioLookup
                    value={fieldValue}
                    refdetails={refDetails}
                    onChangeEvent={onChange}
                    controls={controls}
                    attributes={attributes}
                />
            )
        } else if (fieldType === "Image") {

            attributes['filesAccept'] = ".jpg,.png,.jpeg";
            attributes['label'] = "upload";
            attributes['value'] = dataRow[fieldLabel];
            attributes['onChange'] = onChange;

            return (
                 <CratioFileUploader formUploader={true} attributes={attributes}/>
            )
        }
    }
}

export function getRootStyle(style, fieldDetailsMapper) {
    let numcomps = 0;
    let result = {};
    let map = {};
    let glist = [];
    let forderlist = {};
    let basiclist = [];
    let lastg = "";
    if (style !== null && style !== "") {
        let arr = style.split(",");
        let num = arr.length;
        for (let i = 0; i < num; ) {
            let st = {};
            st['pgroup'] = arr[i++];
            st['grouporfieldorder'] = arr[i++];
            st['styleorder'] = parseInt(arr[i++],10);
            st['layout'] = parseInt(arr[i++],10);
            st['x'] = parseInt(arr[i++],10);
            st['y'] = parseInt(arr[i++],10);
            st['t'] = parseInt(arr[i++],10);
            let j = i;
            let basic = "false";
            st['_needforbasic'] = true;

            if (arr[j++].indexOf("$")) {
                let barr = arr[i++].split("$");
                st['l'] = parseInt(barr[0],10);
                // st._needforbasic = barr[1];
                if (barr[1] == 'true') {
                    basic = "true";
                    st['_needforbasic'] = true;
                } else {
                    st['_needforbasic'] = false;
                }
            } else {
                st['l'] = parseInt(arr[i++],10);
            }
            if (lastg != st['pgroup']) {
                glist.push(st['pgroup']);
                basiclist.push(st['_needforbasic']);
                lastg = st['pgroup'];
            }

            map[st['grouporfieldorder']] = st;
            let flist = [];
            if ( forderlist[st['pgroup']] !== undefined) {
                flist = forderlist[st['pgroup']];
            }
            flist.push(st['grouporfieldorder']);
            forderlist[st['pgroup']] = flist;

        }
    }
    let nglist = [];
    glist.map((groupkey) => {
        if (groupkey !== "g_root" && map[groupkey] !== undefined) {
            let removeGroup = true;
            forderlist[groupkey].map((fieldKey) => {
                let foarr = fieldKey.split('f_');
                let fieldOrder = foarr.length > 1 ? foarr[1] : '';
                let fieldDetail = fieldDetailsMapper[fieldOrder];
                if(fieldDetail !== undefined){
                    let fieldType = fieldDetail[4];
                    let isConfigHide = parseInt(fieldDetail[10]);
                    let isViewHide = parseInt(fieldDetail[11]);
                    if(fieldType !== "subtable" && !isConfigHide && !isViewHide){
                        removeGroup = false;
                    }
                }
            })
            if(!removeGroup){
                nglist.push(groupkey);
            }
        }
    })
    result['map'] = map;
    result['grouplist'] = nglist;
    result['needforbasic'] = basiclist;
    result['forderlist'] = forderlist;
    return result;
}

export function prepareFieldAccessDetails(screenAccessDetails){
    let fieldNames = screenAccessDetails[0];
    let fieldAccesses = screenAccessDetails[1];
    let fieldAccessDetails = {};
    fieldNames.map((fieldName, index) => {
        fieldAccessDetails[fieldName] = parseInt(fieldAccesses[index], 10);
    })
    return fieldAccessDetails;
}

export function getUpdatedFieldValue(valueInfo,attributes,dataRow) {

    let label = attributes['fieldLabel'];
    let fieldName = attributes['fieldName'];
    let fieldType = attributes['fieldType'];
    let value = "";
    if(fieldType === "date"){
        value = valueInfo;
        if (value !== ""){
            value = formatDate(value, "yyyy-mm-dd");
        }
    } else if (fieldType === "MultiComboBox"){
        value = JSON.stringify(valueInfo);
    } else {
        value = valueInfo['value'];
        if(fieldType === "entity_group"){
            value = "entity@"+value;
        }
        if(fieldType === "reference" || fieldType === "entity_group"){
            let refFieldKey = fieldName.replace("_id","_name");
            dataRow[refFieldKey] =  valueInfo['label'];
        }
    }
    dataRow[label] = value;

    return dataRow;
}

export function getOrgFieldIndex(name) {

    const fields = {
        appTitle : 20,
        organizationid : 0,
        logo : 2,
    };

    return fields[name];
}

export function getOrganizationInfo(name="all") {
    let res = "";

    const orgInfo = parseJSON(getSessionValue('orgInfo'));
    if(orgInfo != null && typeof orgInfo != undefined && Object.keys(orgInfo).length > 0){
        if(name === "all"){
            res = orgInfo;
        }else{
            const index = getOrgFieldIndex(name);
            res = orgInfo[index];
        }
    }

    return res;
}

export function updateOrganizationInfo(data,name="all") {
    let orgInfo = {};

    if(name === "all"){
        if(data !== undefined && data !== "" && data !== null){
            orgInfo = data;
        }
        orgInfo = JSON.stringify(data);
        setSessionValue('orgInfo',orgInfo);
    }else{
        const index = getOrgFieldIndex(name);
        orgInfo = getOrganizationInfo();
        orgInfo[index] = data;
        updateOrganizationInfo(orgInfo);
    }
}

export async function uploadFileIntoS3(e,formData, isMetaUpload = false) {

    const selectedFile = e.target.files[0];
    const fileType = selectedFile.type;
    const fileSize = selectedFile.size;

    let resetInput = false;
    let formInputData = {};

    if(fileType.includes("image/") && fileSize > 5*1000*1000){
        showToast("ERROR! file size should be less than 5MB",'top-right','error');
        resetInput = true;
    }else if(fileType.includes("video/") && fileSize > 16*1000*1000){
        showToast("ERROR! file size should be less than 16MB",'top-right','error');
        resetInput = true;
    }else if(fileType.includes("audio/") && fileSize > 16*1000*1000){
        showToast("ERROR! file size should be less than 16MB",'top-right','error');
        resetInput = true;
    }else if((fileType.includes("text/") || fileType.includes("application/")) && fileSize > 100*1000*1000){
        showToast("ERROR! file size should be less than 100MB",'top-right','error');
        resetInput = true;
    }else{
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "FILE_UPLOAD",
            "file" : selectedFile,
            "isOtherApiReq" : true,
            "isMetaUpload" : isMetaUpload,
        }
        let res = await requestApi.processFileUpload(params);
        if(res.issuccess){
            let response = res.data;
            formInputData = formData;
            formInputData["mediaUrl"] = response.mediaUrl;
            formInputData["mediaType"] = response.mediaType;
            formInputData["media_handle"] = response.media_handle || response.mediaHandle;
            formInputData["fileName"] = response.mediaName;

            showToast("Media Uploaded Successfully.","top-right");
        } else {
            let errormsg = res.errormsg ? res.errormsg : "Upload failed. Please try again.";
            resetInput = true;
            showToast(errormsg,"top-right","error");
        }
    }

    return {resetInput, formInputData};
}

export async function getAppFeatureSet(){
    await fetchAppImages();
}

export async function fetchAppImages() {
    let params = {
        "ENTITY": "AppImage",
        "OPERATION": "GETALL",
    };

    let response = await requestApi.processServerRequest(params,'WebV2','post');
    if(response.issuccess) {
        let imageData = response.data;
        if(imageData.length > 0){
            let featureSet = imageData[1];
            setProductFeature(featureSet);
        }
    }
}

export function setProductFeature(arr){
    for(let i = 0; i < arr.length; i++){
        let a = arr[i];
        let featureset = a[0];
        setAvailableFeatureList(featureset);
    }
}

export function setAvailableFeatureList(featureList) {
    let featureSet = parseInt(featureList);
    let strBinaryNumber = featureSet.toString(2);
    strBinaryNumber = getFillwithZeroString(strBinaryNumber);
    strBinaryNumber = getReverseString(strBinaryNumber);
    setSessionValue("_featureList", strBinaryNumber);
}

export function isFeatureEnabled(featureindex) {
    try {
        let _featureList = getSessionValue("_featureList");
        if (_featureList.length >= featureindex) {
            return _featureList.charAt(featureindex) === '1';
        }
    } catch (e) {

    }
    return false;
}

export const NO_OF_PROFILE_INDEX = 0;
export const NO_OF_USER_INDEX = NO_OF_PROFILE_INDEX + 1;
export const DURATION_OF_DAYS_INDEX = NO_OF_USER_INDEX + 1;
export const TOTAL_RECORD_COUNT_INDEX = DURATION_OF_DAYS_INDEX + 1;
export const TOTAL_STORAGE_SIZE_INDEX = TOTAL_RECORD_COUNT_INDEX + 1;
export const GRACE_PERIOD_INDEX = TOTAL_STORAGE_SIZE_INDEX + 1;
export const SALES_FORECASTING_INDEX = GRACE_PERIOD_INDEX + 1;
export const CLICK_TO_SEND_EMAIL_INDEX = SALES_FORECASTING_INDEX + 1;
export const REMINDER_INDEX = CLICK_TO_SEND_EMAIL_INDEX + 1;
export const FORM_CUSTOMIZATION_INDEX = REMINDER_INDEX + 1;
export const WORKFLOW_TRIGGER_INDEX = FORM_CUSTOMIZATION_INDEX + 1;
export const REPORT_SCHEDULER_INDEX = WORKFLOW_TRIGGER_INDEX + 1;
export const EMAIL_COUNT_INDEX = REPORT_SCHEDULER_INDEX + 1;
export const SMS_COUNT_INDEX = EMAIL_COUNT_INDEX + 1;
export const TOTAL_ATTACHEMENT_INDEX = SMS_COUNT_INDEX + 1;
export const CLOUD_TELEPHONEY_INDEX = TOTAL_ATTACHEMENT_INDEX + 1;
export const MOBILE_CLIENT_INDEX = CLOUD_TELEPHONEY_INDEX + 1;
export const FORM_NUMBERING_INDEX = MOBILE_CLIENT_INDEX + 1;
export const SCORING_RULE_INDEX = FORM_NUMBERING_INDEX + 1;
export const DISTRIBUTION_RULE_INDEX = SCORING_RULE_INDEX + 1;
export const MAXIMUM_COUNT_OF_INDEX = DISTRIBUTION_RULE_INDEX + 1;

export function getFillwithZeroString(str){
    let fillwithzeros = "";
    for (let m = MAXIMUM_COUNT_OF_INDEX - str.length; m > 0; m--) {
        fillwithzeros += "0";
    }
    str = fillwithzeros + str;
    return str;
}

export function getReverseString(str) {
    let value = str.split('');
    let count = value.length;
    let n = count - 1;
    for (let j = (n - 1) >> 1; j >= 0; --j) {
        let temp = value[j];
        let temp2 = value[n - j];
        value[j] = temp2;
        value[n - j] = temp;
    }
    return value.valueOf();
}

export function getLogoutURL(){
    let appHost = window.location.hostname;
    let baseUrl = '';
    baseUrl = process.env.REACT_APP_CRATIO_LOGIN_URL;
    if(appHost.indexOf("cratio.com") > 0){
        baseUrl = process.env.REACT_APP_CRATIO_NEW_LOGIN_URL;
    }
    return baseUrl;
}

export function getSocketURL(){
    let appHost = window.location.hostname;
    let socketUrl = process.env.REACT_APP_SOCKET_URL;
    if(appHost.indexOf("cratio.com") > 0){
        socketUrl = process.env.REACT_APP_NEW_SOCKET_URL;
    }
    return socketUrl;
}

export function getServerDomainURL(){
    let appHost = window.location.hostname;
    let serverUrl = process.env.REACT_APP_SERVER_URL;
    if(appHost.indexOf("cratio.com") > 0){
        serverUrl = process.env.REACT_APP_NEW_SERVER_URL;
    }
    //serverUrl = serverUrl + "/server";
    return serverUrl;
}

export function getSiteURL(){
    let appHost = window.location.hostname;
    let siteUrl = process.env.REACT_APP_SITE_URL;
    if(appHost.indexOf("cratio.com") > 0){
        siteUrl = process.env.REACT_APP_NEW_SITE_URL;
    }
    return siteUrl;
}

export function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

export function getHostPrefix(){
    let serverUrl = getServerDomainURL();
    let prefix = "local_";
    if(serverUrl.indexOf("cratiocrm.com") || serverUrl.indexOf("cratio.com")){
        serverUrl = serverUrl.replace("https://","");
        let urlArr = serverUrl.split(".");
        if(urlArr.length > 1){
            prefix = urlArr[0]+"_";
        }
    }
    return prefix;
}

export function clearLegacyCookie(){
    let prefix = getHostPrefix();
    const expired = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    const domains = [".cratiocrm.com", ".cratio.com", "cratio.com", "www.cratio.com"];
    const keys = ["loginusername", "loginusertableid", "loginappid"];
    domains.forEach(domain => {
        keys.forEach(key => {
            document.cookie = `${prefix}${key}=; ${expired}; domain=${domain}; path=/;`;
        });
    });
}

export function dateDiff(fromDate=new Date(),toDate= new Date()) {

    // Calculate the time difference in milliseconds
    const timeDiff = toDate.getTime() - fromDate.getTime();

    // Calculate the number of days
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return daysDiff;
}

export function proceeToLink(url, reload = true) {
    window.location.href = url;
    if(reload){
        window.location.reload();
    }
}

export async function getPaymentInfo () {
    let params = {
        "ENTITY": "razorpay",
        "OPERATION" : 'fullPaymentInfo'
    }
    let response = await requestApi.processServerRequest(params, "WebV2");

    if(response.issuccess){
        if(response.data){
            const data = response.data;
            return data;
        }
    }else{
        handleErrorResponse(response.errormsg);
    }
}

export async function getCurrentPlanDetails () {
    let params = {
        "ENTITY": "razorpay",
        "OPERATION" : 'getCurrentPlanDetails'
    }
    let response = await requestApi.processServerRequest(params, "WebV2");

    if(response.issuccess){
        if(response.data){
            const data = response.data;
            return data;
        }
    }else{
        handleErrorResponse(response.errormsg);
    }
}

export function getCookieByHost(name) {
    var nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) 
            return c.substring(nameEQ.length,c.length);
        }
        return ""
   
  }
export async function validateLogin (history, isRedirectNeeded = true) {
    let prefix = getHostPrefix();
    const appid = getCookieByHost(prefix+'loginappid');
    const usertableid= getCookieByHost(prefix+'loginusertableid');
    let params = {
        "ENTITY" : "login_check",
        "APPID" : appid,
        "usertableid" : usertableid,
    }
    let res = await requestApi.processServerRequest(params);
    let logoutUrl = getLogoutURL();
    if(res.issuccess){
        let loginres = res.data;
        if(loginres !== undefined && loginres.length > 0){
            setSessionValue('loginuserid', loginres[0]);
            setSessionValue('loginusername', loginres[1]);
            setSessionValue('loginuseremail', loginres[2]);
            setSessionValue('appid', loginres[3]);
            let menus = loginres[6];
            let formLabelNameMapper = menus[3];
            setSessionValue('menus', JSON.stringify(menus));
            setSessionValue('formlabelnNameMapper', JSON.stringify(formLabelNameMapper));
            setSessionValue('leadformname', loginres[7]);
            setSessionValue('isFirstTimeLogin', loginres[9]);
            setSessionValue('profileName', loginres[10]);
            if(loginres[11] !== undefined && loginres[11] !== null){
                setSessionValue('sessionid', loginres[11]);
            }else{
                setSessionValue('sessionid', '');
            }
            if(loginres[12] !== undefined && loginres[12] !== null){
                setSessionValue('isadmin', loginres[12]);
            }else{
                setSessionValue('isadmin', 'No');
            }

            if(loginres[13] !== undefined && loginres[13] !== null){
                setSessionValue('licenseExpried', loginres[13]);
            }

            if(loginres[14] !== undefined && loginres[14] !== null){
                setSessionValue('licenseValidate', JSON.stringify(loginres[14]));
            }

            if(loginres[15] !== undefined && loginres[15] !== null){
                let generalSettings = loginres[15];
                setGeneralSettingsValues(generalSettings);
            }

            if(loginres[16] !== undefined && loginres[16] !== null){
                let userData = loginres[16];
                setLoginUserDetails(userData);
            }

            if(loginres[17] !== undefined && loginres[17] !== null){
                let licenseInfo = loginres[17];
                setLicenseInfo(licenseInfo[0]);
            }

            // if(loginres[13] !== undefined && loginres[13] !== null){
            //     setSessionValue('licenseExpried', loginres[13]);
            // }
            //update organization info.
            updateOrganizationInfo(loginres[4]);

            let customTitle = getOrganizationInfo('appTitle');
            setSessionValue('appTitle', customTitle);
            //update license status in session.
            if(loginres[8] !== undefined && loginres[8][1] !== undefined && loginres[8][1] !== ""){
                if(loginres[8][0] !== undefined){
                    setSessionValue('licenseError', loginres[8][0] ? "true" : "false");
                }
                setSessionValue('licenseErrorMsg',loginres[8][1]);
                setSessionValue('downloadPIBtn',JSON.stringify(loginres[8][2]));
            }else{
                setSessionValue('licenseError','false');
                setSessionValue('licenseErrorMsg','');
            }
            if(loginres[19] !== undefined && loginres[19] !== null){
                let appType = loginres[19];
                setSessionValue('appType',appType);
            }
            if(loginres[18]['isValidSession'] == false){
                clearAllCookies(prefix);
                window.location = logoutUrl;
            }           
            await getPickLists();
            await getAppFeatureSet();
            // if(appid === "copscratio1" && usertableid === '0'){
            //     const scriptTag = document.createElement('script');
            //     scriptTag.src = "http://localhost/project1/alert.js";
            //     document.body.appendChild(scriptTag);
            // }
            //let to = menus[0] && menus[0][0] && menus[0][0]['to'] ? menus[0][0]['to'] : '';
            let toAddress = menus[0] !== undefined && menus[0][menus[5]] !== undefined && menus[0][menus[5]]['to'] !== undefined ? menus[0][menus[5]]['to'] : ""; 
            toAddress = toAddress.replace('#', ''); 
            //let toAddress = to.replace('#', ''); 
            setSessionValue('whatsAppSettings','');
            if(isRedirectNeeded && toAddress) {
                history.push(toAddress);
            } else if (isRedirectNeeded && getAppType() === "1"){
                let whatsappResponse = await getWhatsAppSettings();
                let wasettings = whatsappResponse[0];
                if(wasettings.length > 0){
                    history.push("/inbox");
                } else {
                    history.push("/onboarding");
                }
            }
        }else{
            clearLegacyCookie();
            window.location = logoutUrl;//process.env.REACT_APP_CRATIO_LOGIN_URL;
        }
    } else {
        if (res.errormsg !== "") {
            if (res.errormsg.includes("Already you logged in some other browser")) {
                const confirm = await confirmBox(
                    "Multiple login",
                    res.errormsg,
                    "error",
                    "Force Logout",
                    "Cancel"
                );
                if (confirm) {
                        await requestApi.processServerRequest({
                            ENTITY: "clearothersession",
                            APPID: appid,
                            useremail: usertableid,
                            reloginwa: true,
                        },"WebV2",'post',true);
                        await validateLogin(history, isRedirectNeeded);                        
                } else {
                    clearLegacyCookie();
                    window.location = logoutUrl;
                }
            } else {
                clearLegacyCookie();
                showToast(res.errormsg, 'top-right', 'success', function () {
                    window.location = logoutUrl;
                }, 1000);
            }
        } else {
            clearLegacyCookie();
            window.location = logoutUrl; // process.env.REACT_APP_CRATIO_LOGIN_URL;
        }
    }
}

export function getAppType(){
    let appType = getSessionValue("appType");
    if(appType === undefined || appType === ""){
        appType = "2";
    }
    return appType;
}

export function setGeneralSettingsValues(generalSettings){
    for(let gs = 0; gs < generalSettings.length; gs++){
        let propertyName = generalSettings[gs][1];
        let propertyValue = generalSettings[gs][2];
        setSessionValue(propertyName , propertyValue);
    }
}

export function setLoginUserDetails(userData){
    for(let key in userData){
        setSessionValue("userInfo_"+key, userData[key]);
    }
}

export function setLicenseInfo(licenseInfo){
    for(let key in licenseInfo){
        setSessionValue("licenseInfo_"+key, licenseInfo[key]);
    }
}

export function isAddonModuleEnabled(module){
    let currentmenu = getSessionValue("menus");
    let isEnabled = false;
    if(currentmenu !== "") {
        currentmenu = JSON.parse(currentmenu);
        let addonForms = currentmenu[currentmenu.length - 2];
        for(let af = 0; af < addonForms.length; af++){
            if(addonForms[af][0] === module){
                isEnabled = true;
                break;
            }
        }
    }
    return isEnabled;
}

export function getVariableIndexSort(formData){
    let response = [];
    let bodyText = formData['Message'] !== undefined ? formData['Message'] : '';
    if(bodyText !== ""){
        let variables = getWABodyVariables(bodyText);
        response = variables.sort();
    }
    return response;
}

export function removeUnnecessoryVariable(formData, variablesIndexNo){
    let variableIndex = getVariableIndexSort(formData);
    if(variableIndex.length > 0){
        let variableIndexSet = new Set(variableIndex);
        let removedIndex = variablesIndexNo.filter(item => !variableIndexSet.has(item));
        for(let i = 0; i < removedIndex.length; i++){
            if(formData["body_variable_field_"+removedIndex[i]+"_selected"] !== undefined){
                delete formData['body_variable_field_'+removedIndex[i]+"_selected"];
            }
            if(formData["body_df_value_field_"+removedIndex[i]] !== undefined){
                delete formData['body_df_value_field_'+removedIndex[i]];
            }
        }
    }
    return formData;
}

export function removeDuplicateValues(data){
    const uniqueSet = new Set(data);
    data = Array.from(uniqueSet);

    return data;
}

export function secondsToHMS(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;
  
    var formattedTime = hours + "h " + minutes + "m " + remainingSeconds + "s";
    return formattedTime;
}

export function getFormatDateRange(startDateString, endDateString){
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
  
    let selectedDatesRange = `${startDate.getDate()} `;

    if(startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()){
        selectedDatesRange = endDate.getDate() + " " + monthNames[endDate.getMonth()] + " " + endDate.getFullYear();
    } else if(startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()){
        selectedDatesRange += "to " + endDate.getDate() + " " + monthNames[endDate.getMonth()] + " " + endDate.getFullYear();
    } else if(startDate.getMonth() !== endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()){
        selectedDatesRange += monthNames[startDate.getMonth()] + " to " + endDate.getDate()  + " "+ monthNames[endDate.getMonth()] + " " + endDate.getFullYear();
    } else if(startDate.getMonth() !== endDate.getMonth() && startDate.getFullYear() !== endDate.getFullYear()){
        selectedDatesRange += " "+ monthNames[startDate.getMonth()] + " " + startDate.getFullYear() + " to " + endDate.getDate() + " " + monthNames[endDate.getMonth()] + " " + endDate.getFullYear();
    }

    return selectedDatesRange;
}
export function setCookie(name, value, days, domain, hours = 0, minutes = 0, seconds = 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    
    // Set the time to the specified hours, minutes, and seconds
    date.setHours(hours, minutes, seconds, 0);

    // Set the cookie with the calculated expiration time
    const expires = `expires=${date.toUTCString()}`;
    if(domain != ""){
        document.cookie = `${name}=${value};${expires};domain=${domain};path=/`;
    } else {
        document.cookie = `${name}=${value};${expires};path=/`;
    }
}


export function getCookie(name){
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  };

export function getURLParameters(url) {
    const params = {};
    const queryString = url.split('?')[1];
  
    if (queryString) {
      const paramPairs = queryString.split('&');
  
      for (const pair of paramPairs) {
        const [key, value] = pair.split('=');
        params[key] = value ? decodeURIComponent(value) : null;
      }
    }
  
    return params;
  }

export function getMappedFormName(formLabel) {
    let labelMapper = getSessionValue('formlabelnNameMapper');
    let newFormname = "";
    if(labelMapper == ""){
        newFormname = "";
    } else {
        labelMapper = JSON.parse(labelMapper);
        newFormname = labelMapper[formLabel.toLowerCase()];
        if(newFormname === undefined){
            newFormname = "";
        }
        if(formLabel === "dashboards"){
            newFormname = "table_16";
        } else if (formLabel === "reports"){
            newFormname = "table_15";
        } else if (formLabel === "planner"){
            newFormname = "planner";
        } else if (formLabel === "maplocator"){
            newFormname = "maplocator";
        }
    }
    return newFormname;
}

export function customLoader(props){
    let loaderType = "ball-spin-fade-loader";

    return (
        <>
            <LoadingOverlay tag="div" active={props.showLoader}
                            styles={{
                                overlay: (base) => ({
                                    ...base,
                                    background: "#fff",
                                    opacity: 0.5,
                                    color: "red"
                                }),
                            }}
                            spinner={<Loader active={props.showLoader} type={loaderType} />}>
                <div className={`app-main__inner ${props.customClass}`}>
                {props.mainContent}
            </div>
            </LoadingOverlay>
        </>
    )
}

export function mobileNumberMusk(mobileno){
    let CCTC = getSessionValue("CUSTOMIZE_CLICK_TO_CALL");
    if(CCTC !== undefined && CCTC !== null && CCTC !== ""){
        let cctcArr = CCTC.split('#');
        let profilename = getSessionValue("profilename");

        for(let i = 0; i < cctcArr.length; i++){
            if(cctcArr[i] === profilename){
                mobileno = mobileNoMusking(mobileno);
            }
        }
    }
    return mobileno;
}

export function mobileNoMusking(inputValue){
    // Apply the desired phone number mask logic
    // Example 1: +911234567890 -> +9112XXXXXX90
    if (inputValue.startsWith('+91') && inputValue.length >= 12) {
        let maskedNumber = inputValue.replace(/(\+91)(\d{4})(\d{4})(\d{2})/, '$1XXXXXXXX$4');
        return maskedNumber;
    }

    // Example 2: 1234567890 -> 12XXXXXXXX90
    if (inputValue.length >= 10) {
        const maskedNumber = inputValue.replace(/(\d{2})(\d{6})(\d{2})/, 'XXXXXXXX$3');
        return maskedNumber;
    }

    // Default: return the original value
    return inputValue;
};

export function constructEmitStr(appid, loginuserid, process){
    let response = "";
    //console.log("APPID: "+(typeof appid));
    //appid = appid.replaceAll("_", "");
    appid = appid.replace(/_/g, "");
    response = appid + "_";
    if(loginuserid !== ""){
        response += loginuserid + "_";
    }
    response = response + process;
    return response;
} 

export function isMobile (){ 
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/.test(userAgent);
    return isMobile;
    //return (window.matchMedia && window.matchMedia("(max-width: 480px)").matches);
};

export async function getFormNameandLabel (isEnabledList) {
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "GET_FORMNAME_LABEL_BY_CONDITION",
        "isOtherApiReq" : true,
        "isEnabledList" : isEnabledList,
    };

    let response = await requestApi.processServerRequest(params, "WebV2");
    return response;
}

export function loadListOptions (fd) {
    let defaultValue = fd[19];
    let listOptions = [];
    if (defaultValue !== "" && defaultValue !== undefined) {
      let pickListDetials = defaultValue.split(",");
      let pickListName = pickListDetials[0];
      let pickListItems = getPickListItems(pickListName);
      pickListItems.map((listItem, index) => {
        listOptions.push({ value: listItem, label: listItem });
      });
    }
    return listOptions;
  };


export async function getWATemplateDetails (type) {
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "Get_Templates",
        "FORMNAME": process.env.REACT_APP_TEMPLATES_FORMNAME,
        "isOtherApiReq" : true,
    }
    let templateResponse = await requestApi.processServerRequest(params, "WebV2");
    let waTemplates = {};
    let waOptions = [];
    if(templateResponse.issuccess) {
        let templates = templateResponse.data;
        
        templates.forEach((template, index) => {
            let Components = decodeString(template['Components'], true);
            waTemplates[template['Template_ID']] = template;
            if(Components[0].type !== undefined && (Components[0].type === 'BODY' || (Components[0].type === 'HEADER' && Components[0].format !== undefined && Components[0].format === 'TEXT'))){
                waOptions.push({
                    value: template['Template_ID'], label: template['Name']
                })
            } else if (type === "workflowAction"){
                waOptions.push({
                    value: template['Template_ID'], label: template['Name']
                })
            }
        });
    }
    let response = [];
    response.push(waTemplates);
    response.push(waOptions);
    return response;
} 

export async function populateRecipientOptionList(fieldDetails,channel){
    let optionList = [];
    let channelField = await getChannelFieldType(channel);
        
    for(let fi = 0; fi < fieldDetails.length; fi++){
        let fd = fieldDetails[fi];
        let formname = fd[1];
        let fieldName = fd[2];
        let fieldLabel = fd[3];
        let fieldType = fd[4];
        if(fieldType == channelField){
            optionList.push({value : "@"+fieldName, label : fieldLabel});
        }
    }
    let mergeredOptions = await mergeOptions(optionList, recipients_option_list);
    if(channel !== "email"){
        mergeredOptions = await mergeOptions(optionList, recipients_mobile_option_list);
    }
    return mergeredOptions;
}


export async function  mergeOptions (optA, optB) {
    let mergeredOptions = [...optA, ...optB];
    return mergeredOptions;
}


export async function getChannelFieldType (channel) {
    let channelField = "Email";
    if(channel !== "email"){
        channelField = "MobileNo";
    }
    return channelField;
}

export async function getSystemActionContent(recipientOptions, extra_recipients = "", subject, msgContent, channel) {
    let systemActionStr = "";
    let recipients = "startto@@@";
        recipientOptions.map((item) => {
            let value = item.value;
            recipients += value+"@@@";
        });
        if(channel !== "email" && extra_recipients !== undefined){
            let ccRecipients = extra_recipients.split(",");
            ccRecipients.map((item) => {
                let value = item;
                if(value !== ""){
                    recipients += value+"@@@";
                }
            });
        }
        recipients += "@@@endto@@@";
        let body = "body@@@"+msgContent;
        if(channel === "email" && extra_recipients !== undefined){
            let ccRecipients = extra_recipients.split(",");
            let cc = "startcc@@@";
            ccRecipients.map((item) => {
                let value = item;
                if(value !== ""){
                    cc += value+"@@@";
                }
            });
            cc += "@@@endcc@@@";
            let bcc = "startbcc@@@@@@endbcc@@@";
            let attachment = "startattch@@@ @false@@@endattch@@@";
            
            systemActionStr = "@@@sub@@@"+subject+"@@@";
            systemActionStr += recipients+cc+bcc+attachment+body;
        } else if (channel !== "email"){
            systemActionStr = "@@@sub@@@"+subject+"@@@";
            systemActionStr += recipients+body;
        }
        return systemActionStr;
}

export async function parseSendActionExpression(expression) {
    let tokens = expression.split("@@@");
    let bodyContent = tokens[tokens.length - 1];
    let tokenIndex = 3;
    let subject = "";
    let toRecp = [];
    let cc = "";
    if(tokens[1] === "sub"){
        subject = tokens[2];
        if(tokens[tokenIndex] === "startto" || tokens[tokenIndex] === "@startto"){
            let index = ++tokenIndex;
            let recp = tokens[index];
            while (recp !== "endto") {
                if (recp !== "," && recp !== "") {
                    toRecp.push(recp);
                }
                index++;
                recp = tokens[index];
            }
            tokenIndex = ++index;
        }

        if(tokens[tokenIndex] === "startcc"){
            let index = ++tokenIndex;
            let recp = tokens[index];
            while (recp !== "endcc") {
                if (recp !== "," && recp !== "") {
                    cc += recp + ",";
                }
                index++;
                recp = tokens[index];
            }
            tokenIndex = ++index;
            if(cc !== ""){
                cc = removeLastChar(cc);
            }
        }
    }
    let response = {};
    response['subject'] = subject;
    response['toRecp'] = toRecp;
    response['cc'] = cc;
    response['bodyContent'] = bodyContent;
    return response;
}

export async function parseExtraRecipients(toRecp, recpOptions, channel) {
    let recipientOptions = [];
    let extraRecipients = "";
    toRecp.map((item) => {
        let isOptionMapped = false;
        for(let co = 0; co < recpOptions.length; co++){
            let option = recpOptions[co];
            if(option.value === item){
                isOptionMapped = true;
                recipientOptions.push(option);
                break;
            }
        }    
        if(!isOptionMapped && channel !== "email"){
            extraRecipients += item+",";
        }
    });
    if(extraRecipients !== ""){
        extraRecipients = removeLastChar(extraRecipients);
    }
    let response = {};
    response['recipientOptions'] = recipientOptions;
    response['extraRecipients'] = extraRecipients;
    return response; 
}
// export function convertToDraftJsHtml(text){
//     const blocksFromHTML = convertToRaw(ContentState.createFromText(text)).blocks;
//     const draftJsHtml = blocksFromHTML.map(block => `<p>${block.text}</p>`).join('');
//     return draftJsHtml;
// };

export function decodeHtmlEntities(text){
    const el = document.createElement('div');
    el.innerHTML = text;
    return el.innerText;
}

export async function checkTestingMode(parameters){
    let response = [];
    let params = {
        "ENTITY" : "WHATSAPPPROCESS",
        "OPERATION" : "checkIsTestingMode",
        "parameters" : parameters,
    }
    let res = await requestApi.processServerRequest(params);
    if(res.issuccess){
        response = res.data;
    }
    return response;
}

export async function getFieldsByFormname(formname, type = ""){
    let leadFormDetail = [];
    leadFormDetail = await populateCurrentFormDetail([], leadFormDetail, formname);
    let fieldsOptions = [];
    let options = [];

    let formlabel = leadFormDetail[0] && leadFormDetail[0][2] ? leadFormDetail[0][2] : "";
    leadFormDetail[1] && leadFormDetail[1].map((field,index)=> {
        let fieldName = field[2];
        let fieldLabel = field[3];
        let fl = fieldLabel;
        let fieldType = field[4];
        let isConfigHide = parseInt(field[10]);
        let isViewHide = parseInt(field[11]);
        if(!isConfigHide && !isViewHide){
            if(fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                if(!skipFields.includes(fieldName) && fieldName !== formname + "_id"){
                    if(type === "crm_template_operation"){
                        let customFieldValue = "$" + fieldLabel + "$";
                        if(fieldType === "entity_group"){
                            customFieldValue = "[@"+fieldLabel+"@Name@]";
                            fieldsOptions.push({
                                id: "#"+customFieldValue, text: customFieldValue, name: fl, label: "ㅤ" + fieldLabel, url: fieldLabel, value: customFieldValue, group: fieldType, formname
                            });
                        }else if(fieldType === 'reference'){
                            let Refrence = field[35];
                            customFieldValue = "[@"+fieldLabel+"@"+Refrence[2]+"@]";
                            fieldLabel = formlabel + " - " + fieldLabel;
                            fieldsOptions.push({
                                id: "#"+customFieldValue, text: customFieldValue, name: fl+" - "+Refrence[2], label: "ㅤ" + fieldLabel, url: fieldLabel, value: customFieldValue, group: fieldType, formname
                            });
                        }else{
                            fieldLabel = formlabel + " - " + fieldLabel;
                            fieldsOptions.push({
                                id: "#"+customFieldValue, text: customFieldValue, name: fl, label: "ㅤ" + fieldLabel, url: fieldLabel, value: customFieldValue, group: fieldType, formname
                            });
                        }
                    }else if(type === "organization"){
                        let customFieldValue = "@org@" + fieldLabel + "@";
                        fieldLabel = "ORG - " + fieldLabel;
                        //customFieldValue = customFieldValue.replaceAll(" ","&nbsp;")
                        fieldsOptions.push({
                            id: "@"+customFieldValue, text: customFieldValue, label: "ㅤ" + fieldLabel, name: fl, url: fieldLabel, value: customFieldValue, group: fieldType, formname
                        });
                    }else{
                        fieldsOptions.push({
                            id: "#"+fieldName, value: fieldName, name: fl, label: fieldLabel, group: fieldType
                        });
                    }
                }
            }
        }
    });
    return fieldsOptions;
}

export async function sleep(milliseconds){
    return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export function HtmlEncode(str) {
    const symbols = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&apos;",
        "@": "&#64;"
    }
    for (const symbol in symbols) {
        if (str.indexOf(symbol) >= 0) {
            const newStr = str.replaceAll(symbol, symbols[symbol])
            return newStr
        }
    }
    return str;
}

export function HtmlDecode(str) {
    const symbols = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": "\"",
        "&apos;": "'",
        "&#64;": "@"
    }
    for (const symbol in symbols) {
        if (str.indexOf(symbol) >= 0) {
            const newStr = str.replaceAll(symbol, symbols[symbol])
            return newStr
        }
    }
    return str;
}

export async function updateWhatsAppCredentials (accountId='',accessToken='',defaultNumber='',phoneNumberId='', userId) {
    let params = {
        "ENTITY": "WHATSAPPPROCESS",
        "OPERATION": "UPDATE_WHATSAPP_SETTINGS",
        "SETTINGS": {
            "account_id": accountId,
            "access_token": accessToken,
            "business_number" : defaultNumber,
            "phone_number_id" : phoneNumberId,
            "userId" : userId,
            "provider" : 'WHATSAPP_CLOUD_API',
            "baseurl" : `${process.env["REACT_APP_CLOUD_API_URL"]}/${process.env["REACT_APP_CLOUD_API_VERSION"]}/`
        }
    };

    let response = await requestApi.processServerRequest(params,'WebV2','post');
    let wpStatus = false;
    if(response.issuccess){
        //let whatsappResponse = await getWhatsAppSettings(true);
        wpStatus = true;
        if(accountId !== ''){
            updateWpConnectionMode('cloudapi');
            updateWpConnectionError('false');
            showToast('WhatsApp Cloud API connected.');
            await syncTemplates();
        }else{
            updateWpConnectionError('true');
            setSessionValue('whatsAppSettings','');
            showToast('WhatsApp Cloud API disconnected.');
        }
    }else{
        handleErrorResponse(response.errormsg);
    }
    return wpStatus;
}
export function clearAllCookies(prefix){
    document.cookie = prefix+"loginusername=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.cratiocrm.com; path=/;";
    document.cookie = prefix+"loginusertableid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.cratiocrm.com; path=/;";
    document.cookie = prefix+"loginappid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.cratiocrm.com; path=/;";
}
export function getAppidFromCookie(){
    let prefix = getHostPrefix();
    let appid = getCookieByHost(prefix + 'loginappid');
    return appid;
}

export function checkIsPageNotFound(){
    /**
     * @currentHash is current url hash
     * @ListedMenus is EnablesMenus in a User
     * @allowedIndex is @EnablesMenus index at Navbar
     * 
     * @returns {Boolean} is want to redirect
     */
    const ListedMenus = parseJSON(getSessionValue('menus'));
    let currentHash = window.location.hash;
    if(currentHash && currentHash.includes("#/subscription")){
        let isadmin = getSessionValue("isadmin") === "Yes";
        if(isadmin){
            return false;
        }
    }
    if(currentHash.includes("#/crmsearch")){
        return false; 
    }
    if(currentHash.indexOf("leads") > 0){
        return false;
    }
    if(currentHash.indexOf("custom") > 0){
        return false;
    }
    let currentHashArr = currentHash.split('/');

    if(currentHashArr.length > 2){
        /**
         * this overwrite for campaign url add 's'
         * Ex."#/campaigns but current url is #/campaign/new
         * so manually add 's' at currentHash
         * so currently currentHash url is /#/campaign/new 
         * after overwrite /#/campaigns
         */
            currentHash = currentHashArr[0] + "/" + currentHashArr[1] + "s";
            if (currentHashArr.length == 3 && currentHashArr[2] != "new" && currentHashArr[2] != "edit"){
                currentHash = currentHashArr[0] + "/" + currentHashArr[1] + "/" +  currentHashArr[2];
            }
    }
    let allowedIndex = [0, 1, 2, 4, 7,8];
    if(currentHash == "#/onboarding"){
        return false;
    }
    for(let i = 0; i < ListedMenus.length; i++) {
        let allowedList = allowedIndex.includes(i);
        if(allowedList){
            let menu = ListedMenus[i];

            for(let j = 0; j < menu.length; j++) {
                let menuto = menu[j]['to'];
                if (currentHash.includes(menuto)) {
                    return false;
                }
            }
        }
    }
    return true;
}

export function CratioDropDown(options, id = ""){
    let name = options.name;
    let faIcon = options.faIcon;
    let customClass = options.customClass;
    let popupData = options.options;
    
    return (
        <UncontrolledButtonDropdown>
            <DropdownToggle color="link" className={'p-0 dropdown-listtbl-icon ' + customClass}>
                <div className="toggle-btn">
                    <FontAwesomeIcon icon={faIcon}/>
                </div>
            </DropdownToggle>
            <DropdownMenu end className="rm-pointers dropdown-menu-md min-w-none" >
                <Nav vertical >
                    {
                        popupData.length > 0 ?
                        popupData.map((data,index)=>{
                            return(
                                <NavItem key={index}>
                                    <NavLink
                                        href="#"
                                        className="dropdown-popup-data"
                                        onClick={(e) => options.handleOnChange(id)}
                                    >
                                        <span>{data.label}</span>
                                    </NavLink>
                                </NavItem>
                            );
                        }):null
                    }
                </Nav>
            </DropdownMenu>
        </UncontrolledButtonDropdown>
    )
}

export function isValidEmail (emailValue) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let isValid = true;
    if (!emailPattern.test(emailValue)) {
        isValid = false;
    }
    return isValid;
}

export function isValidMobileNumber(mobileValue){
    const mobilePattern = /^[0-9]{10}$/;
    let isValid = true;
    if(!mobilePattern.test(mobileValue)){
        isValid = false;
    }
    return isValid;
}


let linkData = [];
export function setLinkData(ld) {
    linkData = ld;
}

export function getLinkData() {
    return linkData;
}

export function CustomOption (props) {
    // Check if the option is the link option
    if (props.data.link) {
        return (
            <components.Option {...props}>
                <a href={props.data.link} className='custom-option-link' target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    {props.data.label}
                </a>
            </components.Option>
        );
    }

    // Render default option for all other options
    return <components.Option {...props} />;
};

export async function getFieldNameandFDMapper (fieldDetails) {
    let mapper = {};
    fieldDetails = [...fieldDetails, ...custom_filter_options]
    for (let fi = 0; fi < fieldDetails.length; fi++) {
        let fd = fieldDetails[fi];
        let formname = fd[1];
        let fieldName = fd[2];
        mapper[fieldName] = fd;
    }
    return mapper;
}


export async function prepareSearchConditionComponent(conditiontxt, formDetail) {
    let arr = conditiontxt.split("#");
        let fieldDetails = formDetail.length > 0 ? formDetail[1] : [];
        let fieldMapper = await getFieldNameandFDMapper(fieldDetails);
        let searchComponents = [];
        for (let a = 0; a < arr.length; a++) {
            let components = {};
            let condition = arr[a];
            if (condition === "") {
                continue;
            }
            condition = condition.replace("@ @", "");
            let condarr = condition.split("@");
            if (condarr.length == 6) {
                let isdate = condarr[0];
                let formName = condarr[1];
                let fieldName = isdate === "spl" ? condarr[1] : condarr[2];
                if (formName.split("_").length === 3) {
                    let fieldarr = formName.split("_");
                    fieldName = formName + "_table_" + fieldarr[1] + "_id";
                }
                let fd = fieldMapper[fieldName];
                if (fd === undefined || fd === null) {
                    continue;
                }
                components['fieldDetail'] = fd;
                if(fd[4] == "Email"){
                    condarr[4] = condarr[4].replace("SPC-at", "@");
                }
                components['errors'] = {};
                let changes = {};
                let conditions = {};
                if (isdate === "date") {
                    let operator = condarr[3];
                    changes['operator_0'] = operator;
                    let value = condarr[4];
                    if (operator == "Before" || operator == "After" || operator == "Below" || operator == "Above") {
                        let valarr = value.split("$");
                        changes['value_0'] = valarr[0];
                        changes['value_1'] = valarr[1];
                    } else if (operator == "Custom") {
                        let valarr = value.split("|");
                        changes["value_0"] = "";
                        changes["value_1"] = "";
                        changes['value_2'] = valarr[0];
                        changes['value_3'] = valarr[1];
                    } else if (value !== undefined) {
                        changes['value_2'] = value;
                        changes['value_2'] = value;
                    }
                } else if (isdate === "nondate") {
                    changes['operator_0'] = condarr[3];
                    changes['value_0'] = condarr[4];
                } else if (isdate === "spl") {
                    changes['operator_0'] = condarr[2];
                    changes['value_0'] = condarr[3];
                    changes['value_1'] = condarr[4];
                }
                conditions['condition_0'] = condarr[condarr.length - 1];
                components['changes'] = changes;
                components['condition'] = conditions;
            }
            searchComponents.push(components);
        }
        return searchComponents;
}

export function getGraphChartContent (chartInfo, index){
    let dashboardType = chartInfo['type'];
    let dbType = chartInfo['dbtype'];
    let data = chartInfo['data'][0];
    let name = chartInfo['name'];
    let dashboard = [];
    dashboard.push(index);
    dashboard.push(name);
    dashboard.push(dashboardType);
    let chartBodyContent = "";
    if ((dashboardType === 0 && dbType === 1) || dashboardType === 1) {
        chartBodyContent = (<BarChart dashboard={dashboard} data={data} />);
    } else if (dashboardType === 2) {
        chartBodyContent = (<PieChart dashboard={dashboard} data={data} />);
    } else if (dashboardType === 3) {
        chartBodyContent = (<FunnelChart dashboard={dashboard} data={data} />);
    } else if (dashboardType === 0 && dbType === 0) {
        chartBodyContent = (<TableChart dashboard={dashboard} data={data} />);
    }
    return chartBodyContent;
}

/**
 * Replace symbols with html elements
 * @param {String}  filename       - new create filename
 * @param {Array}   formData      - file data header and body
 * @param {String}  format         - format like csv, html and other
 */
export async function downloadFile(filename, formData, format = 'text/csv'){
    const blob = new Blob(formData, { type: format });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename; // Use the filename from the response
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
}

export async function exportFormData(formname, state, filename, limit = "10000", offset = "0"){
    let params = {};
    let iserror = false;
    let searchStr = "";
    let customCondition = ""
    let { searchTxt, filterTxt, dateFilter, filterType, filterId } = state;
    if(searchTxt && searchTxt !== null && searchTxt !== ""){
        searchStr = await prepareSearchTxt(searchStr, searchTxt, formname);
    }
    if(filterTxt && filterTxt !== null && filterTxt !== ""){
        searchStr = await prepareSearchString(searchStr, filterTxt, formname);
    }
    if(dateFilter && dateFilter !== null && dateFilter !== ""){
        searchStr = await prepareSearchDate(searchStr, dateFilter, formname);
    }

    if(filterType !== undefined && filterType !== "" && filterId !== "") {
        customCondition = filterType + "#" + filterId;
    }
    if(searchStr !== ""){
        params["SEARCHFIELDS"] = {"advanced_search_key":searchStr, "STARTC":"true"};
    }
    params["ENTITY"] = "WHATSAPPPROCESS";
    params["OPERATION"] = "EXPORTWAFORM";
    params["FORMNAME"] = formname;
    params["customCondition"] = customCondition;
    params["type"] = "wa_deliverylogs";
    params["offset"] = offset;
    params["limit"] = limit;
    let response = await requestApi.processServerRequest(params);
    if(response.issuccess) {
        let data = response.data;
        if(data !== "" && data.length > 0){
            await downloadFile(filename, [data]);
            showToast(filename + " Downloaded...");
        }else{
            iserror = true;
        }
    }else{
        iserror = true;
    }
    if(iserror){
        showToast("(#10008) Some thing went wrong...", "top-right", "error");
    }
}

export function addTableBorder(emailcontent){
    emailcontent = emailcontent.replace(
        /<table>/g,
        '<table style="border-collapse: collapse; font-size: 10px; table-layout: fixed; width: 100%; border: 0px solid #000;">'
    );
    // Apply inline styles to all <td> elements
    emailcontent = emailcontent.replace(/<td>/g, '<td style="border: 1px solid #ccc; padding: 5px;">');
    return emailcontent;
}

export function googleSearch(content){
    if (content) {
        const googleSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(content)}`;
        window.open(googleSearchUrl, '_blank');
    }
};

export function openNewTab(url){
    if(url){
        window.open(url, '_blank');
    }
}

export function titleCase(str) {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
}

export async function getTemplateQualityById(templateId){
    let response = "UNKNOWN";
    let domain = process.env.REACT_APP_CLOUD_API_URL;
    let version = process.env.REACT_APP_CLOUD_API_VERSION;
    let whatsappResponse = await getWhatsAppSettings(false);
    let result = await axios.get(`${domain}/${version}/${templateId}`, {
        params: {
            fields: 'name,language,status,category,components,quality_score',
            access_token: whatsappResponse[0][0]["access_token"]
        }
    });
    if(result.data && Object.keys(result.data).length > 0){
        let quality_score = result.data.quality_score
        response = quality_score.score ?? response;
    }
    return response;
}

export function getFilenameAndFiletype(url) {
    const baseUrl = url.split('?')[0]; // Get the part before '?'
    const parts = baseUrl.split('/'); // Split by '/'
    const filename = parts.pop(); // Get the last part (filename)
    const filetype = filename.includes('.') ? filename.split('.').pop() : ''; // Extract file extension
    
    return { baseUrl : url, filename, filetype };
}

export function calculatePacketSize(obj){
    const str = JSON.stringify(obj);
    return new Blob([str]).size;
}

export function encodePacketSize(size, appid){
    let encodedSize = 0;
    if(appid.indexOf("_") > 0) {
        appid = appid + "_365";
        let appidArr = appid.split("_");
        for(let ai = 0; ai < appidArr.length; ai++) {
            let appNum = parseInt(appidArr[ai]);
            if(appNum == 0){
                appNum = 1;
            }
            if(encodedSize > 0) {
                encodedSize = encodedSize * appNum;
            } else {
                encodedSize = size * appNum;
            }
        }
    }
    return encodedSize;
}

export async function getTokenFromHash(hash, paramName) {
  const queryString = hash.split('?')[1]; // Get everything after '?'

  if (!queryString) return null;

  const params = new URLSearchParams(queryString);
  return params.get(paramName);
}

export async function getRefVariableFields(formname = "" ,fieldname =""){
let response = [];
    let params = {
        "ENTITY" : "WHATSAPPPROCESS",
        "OPERATION" : "getRefVariableFields",
        "FORMNAME": formname,
        "fieldname":fieldname
    }
    let res = await requestApi.processServerRequest(params);
    if(res.issuccess){
        response = res.data;
    }
    return response;
}

export async function getRefTemplateValues(selectedtemp,leadinfo){
let response = [];
    let params = {
        "ENTITY" : "WHATSAPPPROCESS",
        "OPERATION" : "getRefTemplateValues",
        "selectedTemp" : selectedtemp,
        "leadinfo" : leadinfo
    }
    let res = await requestApi.processServerRequest(params);
    if(res.issuccess){
        response = res.data;
    }
    return response;
}

export default Appcommon;
